import type { ServiceMethodParam, RateCalculationTestResponse, TestLabel, ZonePreviewResponse } from './types';
import { CarrierStatuses } from './types';
import { mockPartner } from '../PartnerService/fixtures';
import uuid from 'uuid-random';
import { FEDEX_SHIPIUM_API_KEY, FEDEX_SHIPIUM_API_PASSWORD } from '../FP_FulfillmentContextService/types';
export const mockCarrierAccountTestLabels: Record<string, TestLabel> = {
  'fedex-ground-service-method': {
    carrier: 'fedex',
    carrierServiceMethodId: 'fedex-ground-service-method',
    zpl: '^XA^CF,0,0,0^PR12^MD30^PW800^CI13^LH0,20^FO12,286^GB755,2,2^FS^FO12,552^GB777,2,2^FS^FO32,165^AdN,0,0^FWN^FH^FDFROM:^FS^FO32,181^AdN,0,0^FWN^FH^FDMac Brown^FS^FO32,199^AdN,0,0^FWN^FH^FDJust Great Cables^FS^FO32,217^AdN,0,0^FWN^FH^FD7511 Greenwood Ave N^FS^FO32,235^AdN,0,0^FWN^FH^FD#525^FS^FO32,271^AdN,0,0^FWN^FH^FDUS ^FS^FO224,165^AdN,0,0^FWN^FH^FD(206) 265-2733^FS^FO478,199^AdN,0,0^FWN^FH^FDCAD: 114075351/WSXI3600^FS^FO28,904^A0N,24,24^FWN^FH^FDTRK#^FS^FO28,962^A0N,27,32^FWN^FH^FD^FS^FO136,874^A0N,27,36^FWN^FH^FD^FS^FO32,253^AdN,0,0^FWN^FH^FDSeattle WA 98103^FS^FO478,165^AdN,0,0^FWN^FH^FDSHIP DATE: 12APR21^FS^FO478,181^AdN,0,0^FWN^FH^FDACTWGT: 3.00 LB^FS^FO478,253^AdN,0,0^FWN^FH^FDBILL SENDER^FS^FO39,298^A0N,39,39^FWN^FH^FDTest Label^FS^FO39,340^A0N,39,39^FWN^FH^FD^FS^FO39,382^A0N,39,39^FWN^FH^FD123 Main Street^FS^FO39,424^A0N,39,39^FWN^FH^FD**TEST LABEL - DO NOT SHIP**^FS^FO39,509^AdN,0,0^FWN^FH^FD(206) 555-1234^FS^FO39,466^A0N,43,40^FWN^FH^FDSeattle WA 98101^FS^FO719,466^A0N,43,40^FWN^FH^FD(US)^FS^FO709,602^A0N,19,26^FWN^FH^FDGround^FS^FO689,642^A0N,128,137^FWN^FH^FDG^FS^FO677,624^GB104,10,10^FS^FO677,634^GB10,112,10^FS^FO771,634^GB10,112,10^FS^FO677,746^GB104,10,10^FS^FO464,160^GB2,126,2^FS^FO654,564^A0N,43,58^FWN^FH^FDFedEx^FS^FO709,602^A0N,19,26^FWN^FH^FDGround^FS^FO689,642^A0N,128,137^FWN^FH^FDG^FS^FO791,655^A0N,13,18^FWB^FH^FDJ211021010401uv^FS^FO9,298^A0N,21,21^FWN^FH^FDTO^FS^FO21,574^BY2,2^B7N,10,5,14^FH^FWN^FH^FD[)>_1E01_1D0298101_1D840_1D019_1D794611202553_1DFDEG_1D8000302_1D102_1D_1D1/1_1D3.00LB_1DN_1D123 Main Street_1DSeattle_1DWA_1DTest Label_1E06_1D10ZGD009_1D12Z2065551234_1D20Z_1C_1D31Z9622001900008000302900794611202553_1D34Z01_1D_1E_04^FS^FO28,999^A0N,107,96^FWN^FH^FD^FS^FO12,843^GB777,2,2^FS^FO494,1047^A0N,43,43^FWN^FH^FD^FS^FO788,190^AbN,11,7^FWB^FH^FD56DJ2/5EF2/FE4A^FS^FO95,908^A0N,53,40^FWN^FH^FD7946 1120 2553^FS^FO409,857^A0N,51,38^FWN^FH^FB390,,,R,^FD                   ^FS^FO404,909^A0N,51,38^FWN^FH^FB400,,,R,^FD                   ^FS^FO413,961^A0N,40,40^FWN^FH^FB386,,,R,^FD                ^FS^FO495,1003^A0N,44,44^FWN^FH^FB298,,,R,^FD     98101^FS^FO574,1063^A0N,24,24^FWN^FH^FB120,,,R,^FD      ^FS^FO695,1047^A0N,43,43^FWN^FH^FB100,,,R,^FD   ^FS^FO39,1089^A0N,27,36^FWN^FH^FD9622 0019 0 (000 800 0302) 9 00 7946 1120 2553^FS^FO75,1130^BY3,2^BCN,200,N,N,N,N^FWN^FD>;9622001900008000302900000000000000^FS^FO478,217^AdN,0,0^FWN^FH^FDDIMMED: 10 X 8 X 3 IN^FS^FO329,511^AbN,11,7^FWN^FH^FDREF: ^FS^FO39,525^AbN,11,7^FWN^FH^FDINV: ^FS^FO39,539^AbN,11,7^FWN^FH^FDPO: ^FS^FO429,539^AbN,11,7^FWN^FH^FDDEPT: ^FS^PQ1^XZ',
    error: false,
  },
  'fedex-home-delivery-service-method': {
    carrier: 'fedex',
    carrierServiceMethodId: 'fedex-home-delivery-service-method',
    zpl: '^XA^CF,0,0,0^PR12^MD30^PW800^CI13^LH0,20^FO12,286^GB755,2,2^FS^FO12,552^GB777,2,2^FS^FO32,165^AdN,0,0^FWN^FH^FDFROM:^FS^FO32,181^AdN,0,0^FWN^FH^FDMac Brown^FS^FO32,199^AdN,0,0^FWN^FH^FDJust Great Cables^FS^FO32,217^AdN,0,0^FWN^FH^FD7511 Greenwood Ave N^FS^FO32,235^AdN,0,0^FWN^FH^FD#525^FS^FO32,271^AdN,0,0^FWN^FH^FDUS ^FS^FO224,165^AdN,0,0^FWN^FH^FD(206) 265-2733^FS^FO478,199^AdN,0,0^FWN^FH^FDCAD: 114075351/WSXI3600^FS^FO28,904^A0N,24,24^FWN^FH^FDTRK#^FS^FO28,962^A0N,27,32^FWN^FH^FD^FS^FO136,874^A0N,27,36^FWN^FH^FD^FS^FO32,253^AdN,0,0^FWN^FH^FDSeattle WA 98103^FS^FO478,165^AdN,0,0^FWN^FH^FDSHIP DATE: 12APR21^FS^FO478,181^AdN,0,0^FWN^FH^FDACTWGT: 3.00 LB^FS^FO478,253^AdN,0,0^FWN^FH^FDBILL SENDER^FS^FO39,298^A0N,39,39^FWN^FH^FDTest Label^FS^FO39,340^A0N,39,39^FWN^FH^FD^FS^FO39,382^A0N,39,39^FWN^FH^FD123 Main Street^FS^FO39,424^A0N,39,39^FWN^FH^FD**TEST LABEL - DO NOT SHIP**^FS^FO39,509^AdN,0,0^FWN^FH^FD(206) 555-1234^FS^FO39,466^A0N,43,40^FWN^FH^FDSeattle WA 98101^FS^FO719,466^A0N,43,40^FWN^FH^FD(US)^FS^FO677,624^GB104,10,10^FS^FO677,634^GB10,112,10^FS^FO771,634^GB10,112,10^FS^FO677,746^GB104,10,10^FS^FO464,160^GB2,126,2^FS^FO687,642^A0N,128,137^FWN^FH^FDH^FS^FO654,564^A0N,43,58^FWN^FH^FDFedEx^FS^FO663,610^AbN,11,7^FWN^FH^FDHome Delivery^FS^FO791,655^A0N,13,18^FWB^FH^FDJ211021010401uv^FS^FO9,298^A0N,21,21^FWN^FH^FDTO^FS^FO21,574^BY2,2^B7N,10,5,14^FH^FWN^FH^FD[)>_1E01_1D0298101_1D840_1D804_1D794611202564_1DFDEG_1D8000302_1D102_1D_1D1/1_1D3.00LB_1DN_1D123 Main Street_1DSeattle_1DWA_1DTest Label_1E06_1D10ZGH007_1D12Z2065551234_1D20Z_1C_1D31Z9622080430008000302900794611202564_1D_1E_04^FS^FO28,999^A0N,107,96^FWN^FH^FD^FS^FO12,843^GB777,2,2^FS^FO494,1047^A0N,43,43^FWN^FH^FD^FS^FO788,190^AbN,11,7^FWB^FH^FD56DJ2/5EF2/FE4A^FS^FO95,908^A0N,53,40^FWN^FH^FD7946 1120 2564^FS^FO409,857^A0N,51,38^FWN^FH^FB390,,,R,^FD                   ^FS^FO404,909^A0N,51,38^FWN^FH^FB400,,,R,^FD                   ^FS^FO413,961^A0N,40,40^FWN^FH^FB386,,,R,^FD                ^FS^FO495,1003^A0N,44,44^FWN^FH^FB298,,,R,^FD     98101^FS^FO574,1063^A0N,24,24^FWN^FH^FB120,,,R,^FD      ^FS^FO695,1047^A0N,43,43^FWN^FH^FB100,,,R,^FD   ^FS^FO39,1089^A0N,27,36^FWN^FH^FD9622 0804 3 (000 800 0302) 9 00 7946 1120 2564^FS^FO75,1130^BY3,2^BCN,200,N,N,N,N^FWN^FD>;9622080430008000302900000000000000^FS^FO478,217^AdN,0,0^FWN^FH^FDDIMMED: 10 X 8 X 3 IN^FS^FO329,511^AbN,11,7^FWN^FH^FDREF: ^FS^FO39,525^AbN,11,7^FWN^FH^FDINV: ^FS^FO39,539^AbN,11,7^FWN^FH^FDPO: ^FS^FO429,539^AbN,11,7^FWN^FH^FDDEPT: ^FS^PQ1^XZ',
    error: false,
  },
  'ups-next-day-air-service-method': {
    carrier: 'ups',
    carrierServiceMethodId: 'ups-next-day-air-service-method',
    zpl: "^XA^LRN^MNY^MFN,N^LH10,12^MCY^PW812^CI27^FO284,524^BY3^BCN,107,N,N,N,A^FV42098101^FS^FO66,792^BY3^BCN,208,N,N,N,A^FV1ZV023V20109985164^FS^FO20,431^CVY^BD2^FH_^FD001840981010000[)>_1E01_1D961Z09985164_1DUPSN_1DV023V2_1E07T8D*Q-MFCF-AC /U&(4E'U:RZY,XTO+8'HO3T#R\"JO(E_0D_1E_04^FS^FO15,7^A0N,20,24^FVMAC BROWN^FS^FO15,27^A0N,20,24^FV2062652733^FS^FO15,47^A0N,20,24^FV7511 GREENWOOD AVE N^FS^FO15,67^A0N,20,24^FVSEATTLE  WA 98103^FS^FO15,142^A0N,28,32^FVSHIP TO: ^FS^FO61,166^A0N,28,32^FV206-555-1234^FS^FO61,194^A0N,28,32^FVTEST LABEL^FS^FO61,222^A0N,28,32^FV123 MAIN STREET^FS^FO61,251^A0N,45,44^FVSEATTLE  WA  98101^FS^FO446,9^A0N,30,34^FV3 LBS^FS^FO683,9^A0N,28,32^FV1 OF 1^FS^FO508,51^A0N,22,26^FVDWT: 10,8,3^FS^FO269,436^A0N,80,70^FVWA 981 9-03^FS^FO10,1031^A0N,22,26^FVBILLING: P/P^FS^FO175,1203^A0N,14,20^FVXOL 21.03.15          NV45 42.0A 01/2021*^FS^FO224,853^A0N,95,74^FVSAMPLE^FS^FO676,674^A0N,100,76^FV1^FS^FO9,670^A0N,56,58^FVUPS NEXT DAY AIR^FS^FO9,731^A0N,26,30^FVTRACKING #: 1Z V02 3V2 01 0998 5164^FS^FO0,648^GB811,14,14,B,0^FS^FO0,423^GB812,4,4,B,0^FS^FO244,423^GB4,225,4,B,0^FS^FO0,774^GB812,5,5,B,0^FS^FO0,1013^GB812,14,14,B,0^FS^FO629,1147^GFA,00969,00969,019,FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000F0000000000001F8000000000000F000000000F0000000000001F8000000000000F000000000F0000000003F81F83FC000000000F000000000F0000000003F81F83FC000000000F000000000F000000000FFF9F9FFF000000000F000000000F000000000FFF9F9FFF000000000F000000000F000000000FFFFFFFFFC00000000F000000000F000000000FFFFFFFFFC00000000F000000000F000000000F07FFFF0FC00000000F000000000F000000000F07FFFF0FC00000000F000000000F000000000FC1FFFC3F000000000F000000000F000000000FC1FFFC3F000000000F000000000F000000000FFFFFFFFF000000000F000000000F000000000FFFFFFFFF000000000F000000000F0000000003FFFFFFFC000000000F000000000F0000000003FFFFFFFC000000000F000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000F00000000001FFFFF00000000000F000000000F00000000001FFFFF00000000000F000000000F00000000003FFF9FC0000000000F000000000F00000000003FFF9FC0000000000F000000000F0000000003FE1F87FC000000000F000000000F0000000003FE1F87FC000000000F000000000F000000000FF81F83FF000000000F000000000F000000000FF81F83FF000000000F000000000F000000000FE01F803F000000000F000000000F000000000FE01F803F000000000F000000000F000000000F001F800F000000000F000000000F000000000F001F800F000000000F000000000F0000000000001F8000000000000F000000000F0000000000001F8000000000000F0FFDC1C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF0FFDC1C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1E3C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1E3C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1A2C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1B6C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1B6C000000000000000000000000000000000C1B6C000000000000000000000000000000000C19CC000000000000000000000000000000000C19CC000000000000000000000000000000000C19CC000000000000000000000000000000000C188C00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000^DN^XZ",
    error: false,
  },
  'ups-ground-service-method': {
    carrier: 'ups',
    carrierServiceMethodId: 'ups-ground-service-method',
    zpl: "^XA^LRN^MNY^MFN,N^LH10,12^MCY^PW812^CI27^FO284,524^BY3^BCN,107,N,N,N,A^FV42098101^FS^FO66,792^BY3^BCN,208,N,N,N,A^FV1ZV023V20309823174^FS^FO20,431^CVY^BD2^FH_^FD003840981010000[)>_1E01_1D961Z09823174_1DUPSN_1DV023V2_1E07T8D*Q-MFCF-AC /U&(4E'U:RZY,XTO+8'HO3T#R\"JO(E_0D_1E_04^FS^FO15,7^A0N,20,24^FVMAC BROWN^FS^FO15,27^A0N,20,24^FV2062652733^FS^FO15,47^A0N,20,24^FV7511 GREENWOOD AVE N^FS^FO15,67^A0N,20,24^FVSEATTLE  WA 98103^FS^FO15,142^A0N,28,32^FVSHIP TO: ^FS^FO61,166^A0N,28,32^FV206-555-1234^FS^FO61,194^A0N,28,32^FVTEST LABEL^FS^FO61,222^A0N,28,32^FV123 MAIN STREET^FS^FO61,251^A0N,45,44^FVSEATTLE  WA  98101^FS^FO446,9^A0N,30,34^FV3 LBS^FS^FO683,9^A0N,28,32^FV1 OF 1^FS^FO508,51^A0N,22,26^FVDWT: 10,8,3^FS^FO269,436^A0N,80,70^FVWA 981 9-03^FS^FO10,1031^A0N,22,26^FVBILLING: P/P^FS^FO175,1203^A0N,14,20^FVXOL 21.03.15          NV45 42.0A 01/2021*^FS^FO224,853^A0N,95,74^FVSAMPLE^FS^FO9,670^A0N,56,58^FVUPS GROUND^FS^FO9,731^A0N,26,30^FVTRACKING #: 1Z V02 3V2 03 0982 3174^FS^FO689,650^GB124,125,124,B,0^FS^FO0,648^GB811,14,14,B,0^FS^FO0,423^GB812,4,4,B,0^FS^FO244,423^GB4,225,4,B,0^FS^FO0,774^GB812,5,5,B,0^FS^FO0,1013^GB812,14,14,B,0^FS^FO629,1147^GFA,00969,00969,019,FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000F0000000000001F8000000000000F000000000F0000000000001F8000000000000F000000000F0000000003F81F83FC000000000F000000000F0000000003F81F83FC000000000F000000000F000000000FFF9F9FFF000000000F000000000F000000000FFF9F9FFF000000000F000000000F000000000FFFFFFFFFC00000000F000000000F000000000FFFFFFFFFC00000000F000000000F000000000F07FFFF0FC00000000F000000000F000000000F07FFFF0FC00000000F000000000F000000000FC1FFFC3F000000000F000000000F000000000FC1FFFC3F000000000F000000000F000000000FFFFFFFFF000000000F000000000F000000000FFFFFFFFF000000000F000000000F0000000003FFFFFFFC000000000F000000000F0000000003FFFFFFFC000000000F000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000FFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000F00000000001FFFFF00000000000F000000000F00000000001FFFFF00000000000F000000000F00000000003FFF9FC0000000000F000000000F00000000003FFF9FC0000000000F000000000F0000000003FE1F87FC000000000F000000000F0000000003FE1F87FC000000000F000000000F000000000FF81F83FF000000000F000000000F000000000FF81F83FF000000000F000000000F000000000FE01F803F000000000F000000000F000000000FE01F803F000000000F000000000F000000000F001F800F000000000F000000000F000000000F001F800F000000000F000000000F0000000000001F8000000000000F000000000F0000000000001F8000000000000F0FFDC1C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF0FFDC1C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1E3C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1E3C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1A2C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1B6C00FFFFFFFFFFFFFFFFFFFFFFFFFFFFF00C1B6C000000000000000000000000000000000C1B6C000000000000000000000000000000000C19CC000000000000000000000000000000000C19CC000000000000000000000000000000000C19CC000000000000000000000000000000000C188C00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000^DN^XZ",
    error: false,
  },
  'usps-parcel-select-service-method': {
    carrier: 'usps',
    carrierServiceMethodId: 'usps-parcel-select-service-method',
    zpl: '^XA^LL1218^PW812^PON^LH0,0^CI27^FO0,0^GB253,225,112,B,0^FS^FO0,40^FR^FB253,1,2,C,0^A0N,192,192^FD ^FS^FO253,0^GB0,224,2,B,0^FS^FO272,11^FB304,1,2,L,0^A0N,20,20^FDUS POSTAGE AND FEES PAID^FS^FO272,93^FB279,1,2,L,0^A0N,23,23^FDMailed from ZIP 98103^FS^FO272,118^FB310,1,2,L,0^A0N,20,20^FDParcel Select Ground^FS^FO272,140^FB310,1,2,L,0^A0N,20,20^FD3 lb Zone 1^FS^FO272,168^FB310,1,2,L,0^A0N,20,20^FD15334615^FS^FO272,192^FB310,1,2,L,0^A0N,20,20^FDCommercialBasePrice^FS^FO567,191^FB196,1,2,C,0^A0N,23,23^FDFakeDeviceID^FS^FO272,68^FB152,1,2,L,0^A0N,23,23^FD* SAMPLE *^FS^FO272,42^FB279,1,2,L,0^A0N,23,23^FDPARCEL SELECT GND^FS^FO583,11^BXN,4,200,0,0,6,~^FH_^FD_7E@_01_02_03_04_05_06_07_08_09_0A_0B_0C_0D_0E_0F_10_11_12_13_14_15_16_17_18_19_1A_1B_1C_1D_1E_1F_20_21_22_23_24_25_26_27_28_29_2A_2B_2C_2D_2E_2F_30_31_32_33_34_35_36_37_38_39_3A_3B_3C_3D_3E_3F_40_41_42_43_44_45_46_47_48_49_4A_4B_4C_4D_4E_4F_50_51_52_53_54_55_56_57_58_59_5A_5B_5C_5D_5E_5F_7E_7E_FF^FS^FO272,61^GB475,63,31,B,0^FS^FO272,83^FR^FB475,1,2,C,0^A0N,23,23^FD*VOID - DO NOT MAIL*^FS^FO750,30^GFA,928,928,8,0000000C000000000000003C7E0000000000007CFF0000000000007CFF00000000000070F7000000000000F0E3000000000000E1E3000000000000E1E3000000000000F1C3000000000000F3C70000000000007FCF0000000000007F8F0000000000003F8E0000000000001F080000000000000007000000000000000700000000000008070000000000003FFF0000000000007FFF0000000000007FFF000000000000FFFF00000003C000F0070000000FF800F0070000003FFC0070070000003FFE0000000000007FFF003F1C00000079CF007F9E000000F1C7007F9F000000E1C780FFDF000000E1C780F1C7000000E1C780E1C3000000F1C700E0C300000079FF0070C300000079FF0070C300000039FE0038E700000019F8007FFF00000001E0007FFF0000000000007FFE0000007FFF00FFFC0000007FFF0000000000007FFF0000000000007FFF007FFF000000403E007FFF0000000006007FFF0000000007007FFF000000000700000E00000000078000070000000007800007000000403F8000070000007FFF0000070000007FFF007FFF0000007FFE007FFF0000007FF8007FFF0000000000007FFE00000003E0007FFE0000001FFC00000F0000003FFE0000070000007FFF0000070000007E3F000007000000F80F00000F000000F007807FFF000000E007807FFF000000E007007FFF0000007007007FFC000000700E0000000000003C1E4400000000007FFFE7FFFF0000007FFFF7FFFF0000007FFFF3FFFF0000007FFFF9FFFF000000000000380E00000000000070070000007FFF1C70070000007FFF1CF0070000007FFF1CF0070000007FFF1CF00F0000000000007C1F0000000000007FFF00000007F0003FFE0000001FFC001FFC0000003FFE0007F00000007FFF0000000000007C1F001C3C000000700F003C7E000000F007807CFF000000E007807CFF000000E00780F0F7000000F00700F1E3000000780F00E1E30000007C1F00E1E30000003E1E00F1C70000003E1E00FFCF0000000E18007FCF0000000000007F8E0000000000003F8C0000007FFF1C0F000000007FFF1C00000000007FFF1C00000000007FFF1C0000000000000000000000000000000000000000003E080000000000007F1C0000000000007F9E000000000000FF9F000000000000F3CF000000000000E1C7000000000000E1C380000000000061C380000000000060C380000000000070E70000000000007FFF0000000000007FFF0000000000007FFF0000000000007FFE0000000000004000000000000000^FS^FO0,241^FB812,1,2,C,0^A0N,46,46^FDUSPS PARCEL SELECT GND�^FS^FO0,224^GB812,0,2,B,0^FS^FO0,294^GB812,0,2,B,0^FS^FO19,310^FB507,1,2,L,0^A0N,23,23^FDJust Great Cables^FS^FO19,335^FB507,1,2,L,0^A0N,23,23^FDMac Brown^FS^FO19,360^FB507,1,2,L,0^A0N,23,23^FD7511 GREENWOOD AVE N # 525^FS^FO19,385^FB507,1,2,L,0^A0N,23,23^FDSEATTLE WA 98103-4627^FS^FO680,317^FB126,1,2,C,0^A0N,40,40^FD1234^FS^FO253,0^FB260,1,2,C,0^A0B,23,23^FD^FS^FO77,583^FB133,1,2,R,0^A0N,25,25^FDSHIP TO:^FS^FO101,621^FB697,1,2,L,0^A0N,28,28^FDTest Label^FS^FO101,651^FB697,1,2,L,0^A0N,28,28^FD123 S MAIN ST^FS^FO101,681^FB697,1,2,L,0^A0N,28,28^FDSEATTLE WA 98104-2515^FS^FO0,862^GB812,0,6,B,0^FS^FO0,880^FB812,1,2,C,0^A0N,34,34^FDTEST TEST TEST^FS^FO73,949^BY3^BCN,152,N,N,N,D^FD42095747>88888888888888888888888^FS^FO0,1147^FB812,1,2,C,0^A0N,34,34^FD8888 8888 8888 8888 8888 88^FS^FO0,1189^GB812,0,6,B,0^FS^FO87,526^GB634,57,28,B,0^FS^FO87,536^FR^FB634,1,2,C,0^A0N,46,46^FDVOID - DO NOT MAIL^FS^FO548,310^FB120,1,2,C,0^A0N,40,40^FDC036^FS^FO545,304^GB126,50,2,B,0^FS^FO201,950^GB406,152,76,B,0^FS^FO201,984^FR^FB406,1,2,C,0^A0N,46,46^FDVOID^FS^FO201,1032^FR^FB406,1,2,C,0^A0N,46,46^FDDO NOT MAIL^FS^XZ',
    error: false,
  },
  'ups-surepost-service-method': {
    carrier: 'ups',
    carrierServiceMethodId: 'ups-surepost-service-method',
    zpl: '^XA^LRN^MNY^MFN,N^LH10,12^MCY^PW812^CI27^FO96,544^BY3^BCN,148,N,N,N,A^FV1ZV023V2YW09354781^FS^FO37,983^BY3^BCN,162,N,N,N,D^FV42098101>892612902938374541400000038^FS^FO295,311^BY3^BCN,107,N,N,N,A^FV420981019998^FS^FO20,221^CVY^BD2^FH_^FD988840981019998[)>_1E01_1D961Z09354781_1DUPSN_1DV023V2_1E07YP6KF7/H)U/6:-KG6Z#P%$D4&_0D7U,#1YXEOH_0DW*_1DJO(E_0D_1E_04^FS^FO15,11^A0N,22,26^FVMAC BROWN^FS^FO15,36^A0N,22,26^FV7511 GREENWOOD AVE N^FS^FO15,60^A0N,22,26^FVSEATTLE WA 98103^FS^FO91,89^A0N,30,34^FVSHIP ^FS^FO91,130^A0N,30,34^FVTO : ^FS^FO188,89^A0N,30,34^FVUSPS 98101^FS^FO188,130^A0N,30,34^FV301 UNION ST^FS^FO188,171^A0N,30,34^FVSEATTLE   WA  98101-9998^FS^FO457,9^A0N,28,32^FV3 LBS^FS^FO264,579^A0N,95,74^FVSAMPLE^FS^FO15,767^A0N,22,26^FVUSPS DELIVER TO: ^FS^FO15,792^A0N,22,26^FVTEST LABEL^FS^FO15,816^A0N,22,26^FV123 MAIN STREET^FS^FO15,840^A0N,22,26^FVSEATTLE, WA 98101^FS^FO236,917^A0N,30,34^FVUSPS TRACKING # eVS ^FS^FO142,1169^A0N,28,32^FV9261 2902 9383 7454 1400 0000 38 ^FS^FO619,737^A0N,18,22^FVPARCEL SELECT^FS^FO602,767^A0N,18,22^FVUS POSTAGE PAID^FS^FO671,793^A0N,18,22^FVUPS^FS^FO671,818^A0N,18,22^FVeVS^FS^FO102,731^A0N,26,30^FVCarrier-Leave If No Response^FS^FO518,51^A0N,22,26^FVDWT: 10,8,3^FS^FO688,9^A0N,28,32^FV1 OF 1^FS^FO15,463^A0N,45,44^FVUPS SUREPOST^FS^FO15,508^A0N,26,30^FVTRACKING #: 1Z V02 3V2 YW 0935 4781^FS^FO295,221^A0N,72,68^FVWA 981 9-03 X^FS^FO690,447^GB122,91,91,B,0^FS^FO0,534^GB812,4,4,B,0^FS^FO0,441^GB812,14,14,B,0^FS^FO0,704^GB812,15,15,B,0^FS^FO0,212^GB812,4,4,B,0^FS^FO244,213^GB4,234,4,B,0^FS^FO0,894^GB812,11,11,B,0^FS^FO0,1207^GB812,11,11,B,0^FS^FO585,845^GB205,4,4,B,0^FS^FO585,727^GB205,3,3,B,0^FS^FO585,727^GB2,122,2,B,0^FS^FO788,727^GB2,122,2,B,0^FS^XZ',
    error: false,
  },
  'usps-priority-mail-service-method': {
    carrier: 'usps',
    carrierServiceMethodId: 'usps-priority-mail-service-method',
    zpl: '^XA^LL1218^PW812^PON^LH0,0^CI27^FO0,40^FB253,1,2,C,0^A0N,192,192^FDP^FS^FO253,0^GB0,224,2,B,0^FS^FO272,11^FB304,1,2,L,0^A0N,20,20^FDUS POSTAGE AND FEES PAID^FS^FO272,93^FB279,1,2,L,0^A0N,23,23^FDMailed from ZIP 98103^FS^FO272,118^FB310,1,2,L,0^A0N,20,20^FD3 lb PM Zone 1^FS^FO272,168^FB310,1,2,L,0^A0N,20,20^FD15334615^FS^FO272,192^FB310,1,2,L,0^A0N,20,20^FDCommercialBasePrice^FS^FO567,191^FB196,1,2,C,0^A0N,23,23^FDFakeDeviceID^FS^FO272,68^FB152,1,2,L,0^A0N,23,23^FD* SAMPLE *^FS^FO272,42^FB279,1,2,L,0^A0N,23,23^FDPRIORITY MAIL^FS^FO583,11^BXN,4,200,0,0,6,~^FH_^FD_7E@_01_02_03_04_05_06_07_08_09_0A_0B_0C_0D_0E_0F_10_11_12_13_14_15_16_17_18_19_1A_1B_1C_1D_1E_1F_20_21_22_23_24_25_26_27_28_29_2A_2B_2C_2D_2E_2F_30_31_32_33_34_35_36_37_38_39_3A_3B_3C_3D_3E_3F_40_41_42_43_44_45_46_47_48_49_4A_4B_4C_4D_4E_4F_50_51_52_53_54_55_56_57_58_59_5A_5B_5C_5D_5E_5F_7E_7E_FF^FS^FO272,61^GB475,63,31,B,0^FS^FO272,83^FR^FB475,1,2,C,0^A0N,23,23^FD*VOID - DO NOT MAIL*^FS^FO750,30^GFA,928,928,8,0000000C000000000000003C7E0000000000007CFF0000000000007CFF00000000000070F7000000000000F0E3000000000000E1E3000000000000E1E3000000000000F1C3000000000000F3C70000000000007FCF0000000000007F8F0000000000003F8E0000000000001F080000000000000007000000000000000700000000000008070000000000003FFF0000000000007FFF0000000000007FFF000000000000FFFF00000003C000F0070000000FF800F0070000003FFC0070070000003FFE0000000000007FFF003F1C00000079CF007F9E000000F1C7007F9F000000E1C780FFDF000000E1C780F1C7000000E1C780E1C3000000F1C700E0C300000079FF0070C300000079FF0070C300000039FE0038E700000019F8007FFF00000001E0007FFF0000000000007FFE0000007FFF00FFFC0000007FFF0000000000007FFF0000000000007FFF007FFF000000403E007FFF0000000006007FFF0000000007007FFF000000000700000E00000000078000070000000007800007000000403F8000070000007FFF0000070000007FFF007FFF0000007FFE007FFF0000007FF8007FFF0000000000007FFE00000003E0007FFE0000001FFC00000F0000003FFE0000070000007FFF0000070000007E3F000007000000F80F00000F000000F007807FFF000000E007807FFF000000E007007FFF0000007007007FFC000000700E0000000000003C1E4400000000007FFFE7FFFF0000007FFFF7FFFF0000007FFFF3FFFF0000007FFFF9FFFF000000000000380E00000000000070070000007FFF1C70070000007FFF1CF0070000007FFF1CF0070000007FFF1CF00F0000000000007C1F0000000000007FFF00000007F0003FFE0000001FFC001FFC0000003FFE0007F00000007FFF0000000000007C1F001C3C000000700F003C7E000000F007807CFF000000E007807CFF000000E00780F0F7000000F00700F1E3000000780F00E1E30000007C1F00E1E30000003E1E00F1C70000003E1E00FFCF0000000E18007FCF0000000000007F8E0000000000003F8C0000007FFF1C0F000000007FFF1C00000000007FFF1C00000000007FFF1C0000000000000000000000000000000000000000003E080000000000007F1C0000000000007F9E000000000000FF9F000000000000F3CF000000000000E1C7000000000000E1C380000000000061C380000000000060C380000000000070E70000000000007FFF0000000000007FFF0000000000007FFF0000000000007FFE0000000000004000000000000000^FS^FO0,241^FB812,1,2,C,0^A0N,46,46^FDPRIORITY MAIL 1-DAY^FS^FO0,224^GB812,0,2,B,0^FS^FO0,294^GB812,0,2,B,0^FS^FO19,310^FB507,1,2,L,0^A0N,23,23^FDJust Great Cables^FS^FO19,335^FB507,1,2,L,0^A0N,23,23^FDMac Brown^FS^FO19,360^FB507,1,2,L,0^A0N,23,23^FD7511 GREENWOOD AVE N # 525^FS^FO19,385^FB507,1,2,L,0^A0N,23,23^FDSEATTLE WA 98103-4627^FS^FO680,317^FB126,1,2,C,0^A0N,40,40^FD1234^FS^FO253,0^FB260,1,2,C,0^A0B,23,23^FD^FS^FO77,583^FB133,1,2,R,0^A0N,25,25^FDSHIP TO:^FS^FO101,621^FB697,1,2,L,0^A0N,28,28^FDTest Label^FS^FO101,651^FB697,1,2,L,0^A0N,28,28^FD123 S MAIN ST^FS^FO101,681^FB697,1,2,L,0^A0N,28,28^FDSEATTLE WA 98104-2515^FS^FO0,862^GB812,0,6,B,0^FS^FO0,880^FB812,1,2,C,0^A0N,34,34^FDTEST TEST TEST^FS^FO73,949^BY3^BCN,152,N,N,N,D^FD42095747>88888888888888888888888^FS^FO0,1147^FB812,1,2,C,0^A0N,34,34^FD8888 8888 8888 8888 8888 88^FS^FO0,1189^GB812,0,6,B,0^FS^FO87,526^GB634,57,28,B,0^FS^FO87,536^FR^FB634,1,2,C,0^A0N,46,46^FDVOID - DO NOT MAIL^FS^FO548,310^FB120,1,2,C,0^A0N,40,40^FDC036^FS^FO545,304^GB126,50,2,B,0^FS^FO201,950^GB406,152,76,B,0^FS^FO201,984^FR^FB406,1,2,C,0^A0N,46,46^FDVOID^FS^FO201,1032^FR^FB406,1,2,C,0^A0N,46,46^FDDO NOT MAIL^FS^XZ',
    error: false,
  },
};
export const mockCarrierRateCalculationResponse: RateCalculationTestResponse = {
  shipiumShipmentId: '4692806d-bf74-413b-950e-1351d7772935',
  partnerShipmentId: '4692806d-bf74-413b-950e-1351d7772935',
  ruleSetUrn: '6C12A6B8-9E04-4E18-ADB7-B0632304459B',
  ruleSetName: 'Default Rule Set',
  carrierLabel: undefined,
  carrierDecision: {
    status: 'success',
    carrier: 'usps',
    carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
    partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
    serviceMethodUrn:
      '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:66b1b1d3-05f8-4d3e-804c-bf783e66f8f0:1',
    serviceMethodName: 'USPS Retail Ground',
    carrierServiceName: 'USPS',
    carrierEstimatedPriceDetails: {
      currencyCode: 'USD',
      totalCost: 5.67,
      shippingCost: 5.67,
      insuranceCost: 0,
      accessorials: 0,
      duty: 0,
      taxes: 0,
    },
    details: {
      filteredServiceMethods: [
        {
          filterReason: 'I just dont like this method',
          filterReasons: ['I just dont like this method', 'This method bullied me in high school'],
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:ac309b02-f0b3-4e4a-a98d-28912bab7681:1',
        },
        {
          filterReason: 'This method only ships on christmas eve',
          filterReasons: ['This method only ships from the north pole', 'Reindeer are actually extremely expensive'],
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:327e3899-9505-4840-9c79-be8310b63d23:1:ec51d5a8-1eed-4e19-9624-535cacfd3303:1',
        },
      ],
      requestParams: {
        currencyCode: 'usd',
        shipmentShipDate: '2020-11-24',
        packagingType: {
          packagingMaterial: 'box',
          packagingSizeName: 'test-package',
          packagingTypeId: null,
          linearDimensions: {
            height: 3,
            length: 9,
            linearUnit: 'in',
            width: 6,
          },
          packagingWeight: {
            weight: 1,
            weightUnit: 'lb',
          },
        },
      },
      availableServiceMethods: [
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '327e3899-9505-4840-9c79-be8310b63d23',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:327e3899-9505-4840-9c79-be8310b63d23:1:ec51d5a8-1eed-4e19-9624-535cacfd3303:1',
          carrier: 'usps',
          carrierServiceName: 'USPS',
          serviceMethodName: 'USPS Retail Ground',
          destinationType: 'all',
          transportationType: 'ground',
          uspsPoBoxDeliverySupported: true,
        },
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:ac309b02-f0b3-4e4a-a98d-28912bab7681:1',
          carrier: 'ups',
          carrierServiceName: 'UPS',
          serviceMethodName: 'UPS Next Day Air',
          destinationType: 'all',
          transportationType: 'air',
          uspsPoBoxDeliverySupported: false,
        },
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:66b1b1d3-05f8-4d3e-804c-bf783e66f8f0:1',
          carrier: 'ups',
          carrierServiceName: 'UPS',
          serviceMethodName: 'UPS SurePost',
          destinationType: 'all',
          transportationType: 'ground',
          uspsPoBoxDeliverySupported: true,
        },
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:af07aa60-bae2-4c14-9d8d-ca355a7ca516:1',
          carrier: 'ups',
          carrierServiceName: 'UPS',
          serviceMethodName: 'UPS Ground Res',
          destinationType: 'residential',
          transportationType: 'ground',
          uspsPoBoxDeliverySupported: false,
        },
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:1b62952d-5a0e-4587-b168-54c1ef5babeb:1',
          carrier: 'ups',
          carrierServiceName: 'UPS',
          serviceMethodName: 'UPS Ground Comm',
          destinationType: 'commercial',
          transportationType: 'ground',
          uspsPoBoxDeliverySupported: false,
        },
      ],
      serviceMethodsAfterFiltering: [
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '327e3899-9505-4840-9c79-be8310b63d23',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:327e3899-9505-4840-9c79-be8310b63d23:1:ec51d5a8-1eed-4e19-9624-535cacfd3303:1',
          carrier: 'usps',
          carrierServiceName: 'USPS',
          serviceMethodName: 'USPS Retail Ground',
          destinationType: 'all',
          transportationType: 'ground',
          uspsPoBoxDeliverySupported: true,
        },
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:ac309b02-f0b3-4e4a-a98d-28912bab7681:1',
          carrier: 'ups',
          carrierServiceName: 'UPS',
          serviceMethodName: 'UPS Next Day Air',
          destinationType: 'all',
          transportationType: 'air',
          uspsPoBoxDeliverySupported: false,
        },
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:66b1b1d3-05f8-4d3e-804c-bf783e66f8f0:1',
          carrier: 'ups',
          carrierServiceName: 'UPS',
          serviceMethodName: 'UPS SurePost',
          destinationType: 'all',
          transportationType: 'ground',
          uspsPoBoxDeliverySupported: true,
        },
        {
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:af07aa60-bae2-4c14-9d8d-ca355a7ca516:1',
          carrier: 'ups',
          carrierServiceName: 'UPS',
          serviceMethodName: 'UPS Ground Res',
          destinationType: 'residential',
          transportationType: 'ground',
          uspsPoBoxDeliverySupported: false,
        },
      ],
      zonesByCarrier: {
        usps: ['usps-zone-3'],
        ups: ['ups-zone-243', 'ups-zone-133', 'ups-zone-3', 'ups-zone-103', 'ups-zone-203', 'ups-zone-303'],
      },
      calculatedRates: [
        {
          actualWeight: 1,
          asOfTime: '2020-11-24T00:00:00Z',
          billableWeight: 1,
          carrierAccountId: '327e3899-9505-4840-9c79-be8310b63d23',
          carrierId: 'usps',
          createdAt: '2020-11-24T19:20:24.556Z',
          destinationAddressType: 'residential',
          destinationCountryCode: 'US',
          destinationPostalCode: '60423',
          dimWeight: null,
          lineItems: [
            {
              name: '2020 Rates',
              rate: 7.25,
              surchargeType: 'base',
            },
          ],
          linearDimensions: {
            height: 3,
            length: 9,
            linearUnit: 'in',
            width: 6,
          },
          packagingMaterial: 'box',
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          physicalWeight: 1,
          rate: 7.25,
          rateCurrency: 'USD',
          rateResultType: 'rate_match',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:327e3899-9505-4840-9c79-be8310b63d23:1:ec51d5a8-1eed-4e19-9624-535cacfd3303:1',
          weightUnit: 'lb',
          zoneId: 'usps-zone-3',
        },
        {
          actualWeight: 1,
          asOfTime: '2020-11-24T00:00:00Z',
          billableWeight: 2,
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          carrierId: 'ups',
          createdAt: '2020-11-24T19:20:24.576Z',
          destinationAddressType: 'residential',
          destinationCountryCode: 'US',
          destinationPostalCode: '60423',
          dimWeight: 2,
          lineItems: [
            {
              name: '2020 Rates',
              rate: 11.76,
              surchargeType: 'base',
            },
            {
              name: 'UPS Residential Air Surcharge',
              rate: 4.7,
              surchargeType: 'residential_air',
            },
            {
              name: 'UPS Domestic Air Fuel Surcharge',
              rate: 0.3822,
              surchargeType: 'fuel_air_domestic',
            },
            {
              name: 'UPS Peak Rule "G" for UPS Next Day Air Residential no-charge 0-109 20201115-20210116',
              rate: 0,
              surchargeType: 'peak',
            },
          ],
          linearDimensions: {
            height: 3,
            length: 9,
            linearUnit: 'in',
            width: 6,
          },
          packagingMaterial: 'box',
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          physicalWeight: 1,
          rate: 16.8422,
          rateCurrency: 'USD',
          rateResultType: 'rate_match',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:ac309b02-f0b3-4e4a-a98d-28912bab7681:1',
          weightUnit: 'lb',
          zoneId: 'ups-zone-103',
        },
        {
          actualWeight: 1,
          asOfTime: '2020-11-24T00:00:00Z',
          billableWeight: 2,
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          carrierId: 'ups',
          createdAt: '2020-11-24T19:20:24.618Z',
          destinationAddressType: 'residential',
          destinationCountryCode: 'US',
          destinationPostalCode: '60423',
          dimWeight: 2,
          lineItems: [
            {
              name: '2020 Rates',
              rate: 5.22,
              surchargeType: 'base',
            },
            {
              name: 'UPS Peak Rule "F" for UPS SurePost packages 20201115-20210116',
              rate: 0.3,
              surchargeType: 'peak',
            },
            {
              name: 'UPS Peak Rule "G" for UPS SurePost no-charge 0-109 20201115-20210116',
              rate: 0,
              surchargeType: 'peak',
            },
          ],
          linearDimensions: {
            height: 3,
            length: 9,
            linearUnit: 'in',
            width: 6,
          },
          packagingMaterial: 'box',
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          physicalWeight: 1,
          rate: 5.52,
          rateCurrency: 'USD',
          rateResultType: 'rate_match',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:66b1b1d3-05f8-4d3e-804c-bf783e66f8f0:1',
          weightUnit: 'lb',
          zoneId: 'ups-zone-3',
        },
        {
          actualWeight: 1,
          asOfTime: '2020-11-24T00:00:00Z',
          billableWeight: 2,
          carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
          carrierId: 'ups',
          createdAt: '2020-11-24T19:20:24.708Z',
          destinationAddressType: 'residential',
          destinationCountryCode: 'US',
          destinationPostalCode: '60423',
          dimWeight: 2,
          lineItems: [
            {
              name: 'UPS Ground Res 2020',
              rate: 7.915,
              surchargeType: 'base',
            },
            {
              name: 'Ground Modifier',
              rate: -4.1,
              surchargeType: 'residential_ground',
            },
            {
              name: 'UPS Residential Ground Surcharge',
              rate: 4.1,
              surchargeType: 'residential_ground',
            },
            {
              name: 'UPS Ground Fuel Surcharge',
              rate: 0.4946875,
              surchargeType: 'fuel_ground',
            },
            {
              name: 'UPS Peak Rule "F" for UPS Ground Residential packages 20201115-20210116',
              rate: 0.3,
              surchargeType: 'peak',
            },
            {
              name: 'UPS Peak Rule "G" for UPS Ground Residential no-charge 0-109 20201115-20210116',
              rate: 0,
              surchargeType: 'peak',
            },
          ],
          linearDimensions: {
            height: 3,
            length: 9,
            linearUnit: 'in',
            width: 6,
          },
          packagingMaterial: 'box',
          partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
          physicalWeight: 1,
          rate: 8.709687,
          rateCurrency: 'USD',
          rateResultType: 'rate_match',
          serviceMethodUrn:
            '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:af07aa60-bae2-4c14-9d8d-ca355a7ca516:1',
          weightUnit: 'lb',
          zoneId: 'ups-zone-3',
        },
      ],
    },
  },
  carrierSelectionDateTime: '2020-06-17T11:36:18-07:00',
  shipmentShipDate: '2020-06-22T17:00:00-07:00',
  carrierSelectionId: 'FD05BE4D-FDEE-4304-85EE-8E19BF227E15',
  carrierSelectionExpiration: '2020-06-17T11:36:18-07:00',
};

export const mockMegaMethodResponse = {
  shipiumShipmentId: '42db8fe9-19dc-4318-b52d-0f67d9740bc4',
  orderedDateTime: '2020-12-23T22:05:23.096Z',
  shippedDateTime: '2020-12-23T22:05:23.096Z',
  deliveredDateTime: null,
  carrierName: null,
  carrierTrackingId: null,
  orderItemQuantities: [
    {
      productId: '123456',
      quantity: 1,
      productDetails: [],
      shipiumOrderId: null,
    },
  ],
  destinationAddress: {
    name: null,
    company: null,
    street1: '22705 Stanford Dr',
    street2: '',
    city: 'Frankfort',
    state: 'IL',
    countryCode: 'US',
    postalCode: '60423',
    addressType: 'residential',
  },
  shipOption: 'Standard',
  shipFromAddress: {
    name: null,
    company: null,
    street1: '1000 Premier Parkway',
    street2: '',
    city: 'St. Charles',
    state: 'MO',
    countryCode: 'US',
    postalCode: '63301',
    addressType: 'commercial',
  },
  fulfillmentCenterId: '085f8f80-d670-4d63-80e3-3ace60a79553',
  packagingType: {
    packagingMaterial: 'box',
    packagingSizeName: 'test-package',
    packagingTypeId: null,
    linearDimensions: {
      height: 3,
      length: 9,
      linearUnit: 'in',
      width: 6,
    },
    packagingWeight: {
      weight: 1,
      weightUnit: 'lb',
    },
  },
  totalWeight: {
    weight: 1,
    weightUnit: 'lb',
  },
  shipmentTags: [],
  carrierSelection: {
    carrierSelectionId: '4dce019c-b5b6-42a1-9a73-b3ef3c83af7d',
    shipiumShipmentId: '42db8fe9-19dc-4318-b52d-0f67d9740bc4',
    partnerShipmentId: null,
    partnerId: '3060a3db-0678-4459-bd2e-f7c501ee4b3f',
    carrierAccountId: '98d52198-aee8-4aba-8709-ce0380cc0578',
    serviceMethodUrn:
      '3060a3db-0678-4459-bd2e-f7c501ee4b3f:98d52198-aee8-4aba-8709-ce0380cc0578:1:66b1b1d3-05f8-4d3e-804c-bf783e66f8f0:1',
    carrier: 'ups',
    serviceMethodName: 'UPS SurePost',
    totalCost: 5.52,
    carrierSelectionDateTime: '2020-12-23T22:07:20.82Z',
  },
  carrierLabel: {
    shipiumShipmentId: null,
    partnerShipmentId: null,
    carrierSelectionId: '4dce019c-b5b6-42a1-9a73-b3ef3c83af7d',
    shipiumLabelId: 'heres how you can find me',
    carrier: 'ups',
    carrierServiceName: 'UPS',
    carrierTrackingId: 'One day this will be a real tracking id',
    carrierTrackingLink: 'This will become useful eventually',
    carrierLabelCurrencyCode: 'usd',
    carrierLabelPrice: 5.52,
    documents: [
      {
        labelFormat: 'png',
        labelUrl: 'where one would get it',
        labelExpiration: '2020-12-30T22:07:21.229Z',
        labelImage: {
          imageEncoding: 'base64',
          imageContents: 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=',
        },
      },
      {
        labelFormat: 'zpl',
        labelUrl: 'where one would get it',
        labelExpiration: '2020-12-30T22:07:21.23Z',
        labelImage: {
          imageEncoding: 'base64',
          imageContents:
            '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',
        },
      },
    ],
  },
};

export const mockZonePreviewResponse: ZonePreviewResponse = {
  previewId: 'test-preview-id',
  metadata: {
    a: 'b',
    previous: 'test-previous-zones',
    key: 'test-key',
  },
  diff: {
    added: [
      {
        key: 'aa',
        zones: ['11'],
      },
      {
        key: 'bb',
        zones: ['22'],
      },
    ],
    removed: [
      {
        key: 'cc',
        zones: ['33'],
      },
      {
        key: 'dd',
        zones: ['44'],
      },
    ],
    modified: [
      {
        key: 'ee',
        before: ['55', '66'],
        after: ['55'],
      },
      {
        key: 'ff',
        before: ['77', '88'],
        after: ['111', '77', '88', '99'],
      },
    ],
  },
};

export const serviceMethodParam: ServiceMethodParam = {
  serviceMethodParamId: '3a7e6821-4e99-4c74-a6b8-4a712b460665',
  serviceMethodParamUrn: 'xxxx:xxx:xxxxxx:xxx',
  serviceMethodUrn: 'yyyy:yyyyy:yyyyy',
  name: '2020 Rate Table',
  startDateTime: '2020-01-01T08:00:00.000Z',
  endDateTime: '2021-01-01T08:00:00.000Z',
  rateTable: {
    currency: 'USD',
    rates: {
      1: {
        'Zone 2': 1.55,
        'Zone 3': 2.44,
      },
      2: {
        'Zone 2': 2.33,
        'Zone 3': 2.55,
        'Zone 4': 2.79,
      },
      3: {
        'Zone 2': 3.01,
        'Zone 3': 3.19,
        'Zone 4': 3.56,
      },
    },
  },
  active: true,
  negotiatedSurcharges: [
    {
      modifierValue: 0.01,
      modifierType: 'percentage',
      surchargeId: 'ups-das-air-commercial',
      name: 'UPS DAS',
    },
  ],
};

export const carriers: any[] = [
  {
    carrierId: 'upsmi',
    name: 'United Parcel Service Mail Innovations (UPS MI)',
    status: CarrierStatuses.AVAILABLE,
    credentialStructures: [
      {
        credentialStructureId: 'ups-standard-credentials',
        name: 'UPS Standard Credentials',
        credentialProperties: [
          {
            credentialId: 'ups-account-number',
            name: 'UPS Account Number',
          },
        ],
      },
    ],
    shipiumCredentialStructures: [],
    maxTrackingIdRequestCount: 100,
    serviceMethods: [
      {
        serviceMethodId: 'upsmi-parcel-select-service-method',
        name: 'UPS Mail Innovations Parcel Select',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        status: CarrierStatuses.AVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'ups-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ups-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ups-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ups-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ups-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'ups-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'ups-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'ups-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'ups-zone-10',
            name: 'Zone 10',
          },
          {
            zoneId: 'ups-zone-11',
            name: 'Zone 11',
          },
          {
            zoneId: 'ups-zone-12',
            name: 'Zone 12',
          },
          {
            zoneId: 'ups-zone-13',
            name: 'Zone 13',
          },
        ],
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'upsmi-parcel-select-lightweight-service-method',
        name: 'UPS Mail Innovations Parcel Select Lightweight',
        status: CarrierStatuses.UNAVAILABLE,
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'sub_units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'ups-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ups-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ups-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ups-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ups-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'ups-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'ups-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'ups-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'ups-zone-10',
            name: 'Zone 10',
          },
          {
            zoneId: 'ups-zone-11',
            name: 'Zone 11',
          },
          {
            zoneId: 'ups-zone-12',
            name: 'Zone 12',
          },
          {
            zoneId: 'ups-zone-13',
            name: 'Zone 13',
          },
        ],
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'upsmi-priority-service-method',
        name: 'UPS Mail Innovations Priority',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'three_day',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'ups-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ups-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ups-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ups-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ups-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'ups-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'ups-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'ups-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'ups-zone-10',
            name: 'Zone 10',
          },
          {
            zoneId: 'ups-zone-11',
            name: 'Zone 11',
          },
          {
            zoneId: 'ups-zone-12',
            name: 'Zone 12',
          },
          {
            zoneId: 'ups-zone-13',
            name: 'Zone 13',
          },
        ],
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
    ],
    returnsServiceMethods: [],
    surchargeTypes: ['fuel_ground'],
    fuelSurchargeAppliedToOnlyBaseRate: false,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
      {
        height: 8.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
    ],
    validLabelDpis: [203],
    active: true,
  },
  {
    carrierId: 'ontrac',
    name: 'OnTrac',
    status: CarrierStatuses.AVAILABLE,
    credentialStructures: [
      {
        credentialStructureId: 'ontrac-standard-credentials',
        name: 'OnTrac Standard Credentials',
        credentialProperties: [
          {
            credentialId: 'ontrac-account-number',
            name: 'OnTrac Account Number',
          },
          {
            credentialId: 'ontrac-web-password',
            name: 'OnTrac Web Password',
          },
        ],
      },
    ],
    shipiumCredentialStructures: [],
    maxTrackingIdRequestCount: 100,
    serviceMethods: [
      {
        serviceMethodId: 'ontrac-ground-service-method',
        status: CarrierStatuses.AVAILABLE,
        name: 'OnTrac Ground',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 72.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'ontrac-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ontrac-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ontrac-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ontrac-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ontrac-zone-6',
            name: 'Zone 6',
          },
        ],
        supportedDeliverySignatureTypes: ['signature'],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ontrac-sunrise-service-method',
        name: 'OnTrac Sunrise',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'overnight',
        status: CarrierStatuses.AVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 72.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'ontrac-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ontrac-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ontrac-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ontrac-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ontrac-zone-6',
            name: 'Zone 6',
          },
        ],
        supportedDeliverySignatureTypes: ['signature'],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
    ],
    returnsServiceMethods: [],
    surchargeTypes: [
      'residential_ground',
      'fuel_ground',
      'delivery_commercial_ground',
      'delivery_residential_ground',
      'extended_delivery_commercial_ground',
      'extended_delivery_residential_ground',
      'saturday_delivery',
      'signature',
    ],
    fuelSurchargeAppliedToOnlyBaseRate: true,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
    ],
    validLabelDpis: [203],
    active: true,
  },
  {
    carrierId: 'ups',
    name: 'United Parcel Service (UPS)',
    credentialStructures: [
      {
        credentialStructureId: 'ups-standard-credentials',
        name: 'UPS Standard Credentials',
        credentialProperties: [
          {
            credentialId: 'ups-account-number',
            name: 'UPS Account Number',
          },
        ],
      },
    ],
    shipiumCredentialStructures: [],
    maxTrackingIdRequestCount: 100,
    status: CarrierStatuses.AVAILABLE_SHIPIUM,
    serviceMethods: [
      {
        serviceMethodId: 'ups-next-day-air-early-service-method',
        name: 'UPS Next Day Air Early',
        credentialStructures: null,
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        applicableSurchargeIds: [
          'ups-das-air-commercial',
          'ups-edas-air-commercial',
          'ups-das-air-residential',
          'ups-edas-air-residential',
          'ups-rdas',
          'ups-rdas-alaska',
          'ups-rdas-hawaii',
          'ups-residential-air-domestic',
          'ups-handling-large-package-commercial-zone-2',
          'ups-handling-large-package-commercial-zone-3-4',
          'ups-handling-large-package-commercial-zone-5-plus',
          'ups-handling-large-package-residential-zone-2',
          'ups-handling-large-package-residential-zone-3-4',
          'ups-handling-large-package-residential-zone-5-plus',
          'ups-handling-weight-zone-2',
          'ups-handling-weight-zone-3-4',
          'ups-handling-weight-zone-5plus',
          'ups-handling-dimension-zone-2',
          'ups-handling-dimension-zone-3-4',
          'ups-handling-dimension-zone-5plus',
          'ups-peak-large-package',
          'ups-peak-handling',
          'ups-saturday',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-domestic',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'supported',
            countries: ['US'],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'next_day',
        applicableServiceLevels: ['next_day'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-102',
            name: 'Zone 102',
          },
          {
            zoneId: 'ups-zone-103',
            name: 'Zone 103',
          },
          {
            zoneId: 'ups-zone-104',
            name: 'Zone 104',
          },
          {
            zoneId: 'ups-zone-105',
            name: 'Zone 105',
          },
          {
            zoneId: 'ups-zone-106',
            name: 'Zone 106',
          },
          {
            zoneId: 'ups-zone-107',
            name: 'Zone 107',
          },
          {
            zoneId: 'ups-zone-108',
            name: 'Zone 108',
          },
          {
            zoneId: 'ups-zone-124',
            name: 'Zone 124',
          },
        ],
        supportedDeliverySignatureTypes: ['resident_signature', 'adult_signature', 'adult_resident_signature'],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-next-day-air-service-method',
        name: 'UPS Next Day Air',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        applicableSurchargeIds: [
          'ups-das-air-commercial',
          'ups-edas-air-commercial',
          'ups-das-air-residential',
          'ups-edas-air-residential',
          'ups-rdas',
          'ups-rdas-alaska',
          'ups-rdas-hawaii',
          'ups-residential-air-domestic',
          'ups-handling-large-package-commercial-zone-2',
          'ups-handling-large-package-commercial-zone-3-4',
          'ups-handling-large-package-commercial-zone-5-plus',
          'ups-handling-large-package-residential-zone-2',
          'ups-handling-large-package-residential-zone-3-4',
          'ups-handling-large-package-residential-zone-5-plus',
          'ups-handling-weight-zone-2',
          'ups-handling-weight-zone-3-4',
          'ups-handling-weight-zone-5plus',
          'ups-handling-dimension-zone-2',
          'ups-handling-dimension-zone-3-4',
          'ups-handling-dimension-zone-5plus',
          'ups-peak-large-package',
          'ups-peak-handling',
          'ups-saturday',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-domestic',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'supported',
            countries: ['US'],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'next_day',
        applicableServiceLevels: ['next_day'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
          PR: 'any_country_to_any_country',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-102',
            name: 'Zone 102',
          },
          {
            zoneId: 'ups-zone-103',
            name: 'Zone 103',
          },
          {
            zoneId: 'ups-zone-104',
            name: 'Zone 104',
          },
          {
            zoneId: 'ups-zone-105',
            name: 'Zone 105',
          },
          {
            zoneId: 'ups-zone-106',
            name: 'Zone 106',
          },
          {
            zoneId: 'ups-zone-107',
            name: 'Zone 107',
          },
          {
            zoneId: 'ups-zone-108',
            name: 'Zone 108',
          },
          {
            zoneId: 'ups-zone-124',
            name: 'Zone 124',
          },
          {
            zoneId: 'ups-zone-125',
            name: 'Zone 125',
          },
          {
            zoneId: 'ups-zone-126',
            name: 'Zone 126',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-next-day-air-saver-service-method',
        name: 'UPS Next Day Air Saver',
        credentialStructures: null,
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        applicableSurchargeIds: [
          'ups-das-air-commercial',
          'ups-edas-air-commercial',
          'ups-das-air-residential',
          'ups-edas-air-residential',
          'ups-rdas',
          'ups-rdas-alaska',
          'ups-rdas-hawaii',
          'ups-residential-air-domestic',
          'ups-handling-large-package-commercial-zone-2',
          'ups-handling-large-package-commercial-zone-3-4',
          'ups-handling-large-package-commercial-zone-5-plus',
          'ups-handling-large-package-residential-zone-2',
          'ups-handling-large-package-residential-zone-3-4',
          'ups-handling-large-package-residential-zone-5-plus',
          'ups-handling-weight-zone-2',
          'ups-handling-weight-zone-3-4',
          'ups-handling-weight-zone-5plus',
          'ups-handling-dimension-zone-2',
          'ups-handling-dimension-zone-3-4',
          'ups-handling-dimension-zone-5plus',
          'ups-peak-large-package',
          'ups-peak-handling',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-domestic',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'supported',
            countries: ['US'],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'next_day',
        applicableServiceLevels: ['next_day'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-132',
            name: 'Zone 132',
          },
          {
            zoneId: 'ups-zone-133',
            name: 'Zone 133',
          },
          {
            zoneId: 'ups-zone-134',
            name: 'Zone 134',
          },
          {
            zoneId: 'ups-zone-135',
            name: 'Zone 135',
          },
          {
            zoneId: 'ups-zone-136',
            name: 'Zone 136',
          },
          {
            zoneId: 'ups-zone-137',
            name: 'Zone 137',
          },
          {
            zoneId: 'ups-zone-138',
            name: 'Zone 138',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'ups-2nd-day-air-am-service-method',
        name: 'UPS 2nd Day Air A.M.',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        applicableSurchargeIds: [
          'ups-das-air-commercial',
          'ups-edas-air-commercial',
          'ups-das-air-residential',
          'ups-edas-air-residential',
          'ups-rdas',
          'ups-rdas-alaska',
          'ups-rdas-hawaii',
          'ups-residential-air-domestic',
          'ups-handling-large-package-commercial-zone-2',
          'ups-handling-large-package-commercial-zone-3-4',
          'ups-handling-large-package-commercial-zone-5-plus',
          'ups-handling-large-package-residential-zone-2',
          'ups-handling-large-package-residential-zone-3-4',
          'ups-handling-large-package-residential-zone-5-plus',
          'ups-handling-weight-zone-2',
          'ups-handling-weight-zone-3-4',
          'ups-handling-weight-zone-5plus',
          'ups-handling-dimension-zone-2',
          'ups-handling-dimension-zone-3-4',
          'ups-handling-dimension-zone-5plus',
          'ups-peak-large-package',
          'ups-peak-handling',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-domestic',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'supported',
            countries: ['US'],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'two_day_morning',
        applicableServiceLevels: ['two_day_morning', 'two_day'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-242',
            name: 'Zone 242',
          },
          {
            zoneId: 'ups-zone-243',
            name: 'Zone 243',
          },
          {
            zoneId: 'ups-zone-244',
            name: 'Zone 244',
          },
          {
            zoneId: 'ups-zone-245',
            name: 'Zone 245',
          },
          {
            zoneId: 'ups-zone-246',
            name: 'Zone 246',
          },
          {
            zoneId: 'ups-zone-247',
            name: 'Zone 247',
          },
          {
            zoneId: 'ups-zone-248',
            name: 'Zone 248',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'ups-2nd-day-air-service-method',
        name: 'UPS 2nd Day Air',
        credentialStructures: null,
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        applicableSurchargeIds: [
          'ups-das-air-commercial',
          'ups-edas-air-commercial',
          'ups-das-air-residential',
          'ups-edas-air-residential',
          'ups-rdas',
          'ups-rdas-alaska',
          'ups-rdas-hawaii',
          'ups-residential-air-domestic',
          'ups-handling-large-package-commercial-zone-2',
          'ups-handling-large-package-commercial-zone-3-4',
          'ups-handling-large-package-commercial-zone-5-plus',
          'ups-handling-large-package-residential-zone-2',
          'ups-handling-large-package-residential-zone-3-4',
          'ups-handling-large-package-residential-zone-5-plus',
          'ups-handling-weight-zone-2',
          'ups-handling-weight-zone-3-4',
          'ups-handling-weight-zone-5plus',
          'ups-handling-dimension-zone-2',
          'ups-handling-dimension-zone-3-4',
          'ups-handling-dimension-zone-5plus',
          'ups-peak-large-package',
          'ups-peak-handling',
          'ups-saturday',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-domestic',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'supported',
            countries: ['US'],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'two_day',
        applicableServiceLevels: ['two_day'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
          PR: 'any_country_to_any_country',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-202',
            name: 'Zone 202',
          },
          {
            zoneId: 'ups-zone-203',
            name: 'Zone 203',
          },
          {
            zoneId: 'ups-zone-204',
            name: 'Zone 204',
          },
          {
            zoneId: 'ups-zone-205',
            name: 'Zone 205',
          },
          {
            zoneId: 'ups-zone-206',
            name: 'Zone 206',
          },
          {
            zoneId: 'ups-zone-207',
            name: 'Zone 207',
          },
          {
            zoneId: 'ups-zone-208',
            name: 'Zone 208',
          },
          {
            zoneId: 'ups-zone-224',
            name: 'Zone 224',
          },
          {
            zoneId: 'ups-zone-225',
            name: 'Zone 225',
          },
          {
            zoneId: 'ups-zone-226',
            name: 'Zone 226',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-3-day-select-service-method',
        name: 'UPS 3 Day Select',
        credentialStructures: null,
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        applicableSurchargeIds: [
          'ups-das-air-commercial',
          'ups-edas-air-commercial',
          'ups-das-air-residential',
          'ups-edas-air-residential',
          'ups-rdas',
          'ups-rdas-alaska',
          'ups-rdas-hawaii',
          'ups-residential-air-domestic',
          'ups-handling-large-package-commercial-zone-2',
          'ups-handling-large-package-commercial-zone-3-4',
          'ups-handling-large-package-commercial-zone-5-plus',
          'ups-handling-large-package-residential-zone-2',
          'ups-handling-large-package-residential-zone-3-4',
          'ups-handling-large-package-residential-zone-5-plus',
          'ups-handling-weight-zone-2',
          'ups-handling-weight-zone-3-4',
          'ups-handling-weight-zone-5plus',
          'ups-handling-dimension-zone-2',
          'ups-handling-dimension-zone-3-4',
          'ups-handling-dimension-zone-5plus',
          'ups-peak-large-package',
          'ups-peak-handling',
          'ups-saturday-commercial',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-domestic',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'supported',
            countries: ['US'],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'three_day',
        applicableServiceLevels: ['three_day'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-302',
            name: 'Zone 302',
          },
          {
            zoneId: 'ups-zone-303',
            name: 'Zone 303',
          },
          {
            zoneId: 'ups-zone-304',
            name: 'Zone 304',
          },
          {
            zoneId: 'ups-zone-305',
            name: 'Zone 305',
          },
          {
            zoneId: 'ups-zone-306',
            name: 'Zone 306',
          },
          {
            zoneId: 'ups-zone-307',
            name: 'Zone 307',
          },
          {
            zoneId: 'ups-zone-308',
            name: 'Zone 308',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-ground-service-method',
        name: 'UPS Ground',
        credentialStructures: null,
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        applicableSurchargeIds: [
          'ups-das-ground-commercial',
          'ups-edas-ground-commercial',
          'ups-das-ground-residential',
          'ups-edas-ground-residential',
          'ups-rdas',
          'ups-rdas-alaska',
          'ups-rdas-hawaii',
          'ups-residential-ground',
          'ups-handling-large-package-commercial-zone-2',
          'ups-handling-large-package-commercial-zone-3-4',
          'ups-handling-large-package-commercial-zone-5-plus',
          'ups-handling-large-package-residential-zone-2',
          'ups-handling-large-package-residential-zone-3-4',
          'ups-handling-large-package-residential-zone-5-plus',
          'ups-handling-weight-zone-2',
          'ups-handling-weight-zone-3-4',
          'ups-handling-weight-zone-5plus',
          'ups-handling-dimension-zone-2',
          'ups-handling-dimension-zone-3-4',
          'ups-handling-dimension-zone-5plus',
          'ups-peak-large-package',
          'ups-peak-handling',
          'ups-peak-ground-residential',
          'ups-saturday-commercial',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-ground',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'supported',
            countries: ['US'],
            exclusionsByRegion: {
              US: ['AA', 'HI', 'AS', 'PR', 'VI', 'AE', 'CZ', 'AK', 'GU', 'AP'],
            },
            exclusionsByPostalCode: {
              US: [
                '43456',
                '43446',
                '49757',
                '98279',
                '98245',
                '98286',
                '98297',
                '43438',
                '98222',
                '98243',
                '98262',
                '98250',
                '98261',
                '98280',
                '49782',
                '90704',
              ],
            },
          },
        },
        serviceLevel: 'standard',
        applicableServiceLevels: ['standard'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
          PR: 'any_country_to_any_country',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ups-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ups-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ups-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ups-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'ups-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'ups-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'ups-zone-44',
            name: 'Zone 44',
          },
          {
            zoneId: 'ups-zone-45',
            name: 'Zone 45',
          },
          {
            zoneId: 'ups-zone-46',
            name: 'Zone 46',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-surepost-service-method',
        name: 'UPS SurePost',
        credentialStructures: null,
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        applicableSurchargeIds: [
          'ups-das-surepost',
          'ups-edas-surepost',
          'ups-surepost-handling',
          'ups-surepost-peak-handling',
          'ups-peak-surepost',
          'ups-fuel-ground',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'carrier_approval_required',
            countries: ['US'],
            exclusionsByRegion: {
              US: ['AA', 'HI', 'AS', 'PR', 'VI', 'AE', 'CZ', 'AK', 'GU', 'AP'],
            },
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'standard',
        applicableServiceLevels: ['standard'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 60.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'min',
              combined: 0.0,
              length: 6.0,
              width: 4.0,
              height: 0.75,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
            {
              packageType: 'box',
              thresholdType: 'floor',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: true,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ups-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ups-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ups-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ups-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'ups-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'ups-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'ups-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'ups-zone-10',
            name: 'Zone 10',
          },
          {
            zoneId: 'ups-zone-11',
            name: 'Zone 11',
          },
          {
            zoneId: 'ups-zone-12',
            name: 'Zone 12',
          },
          {
            zoneId: 'ups-zone-13',
            name: 'Zone 13',
          },
        ],
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-surepost-lt-1lb-service-method',
        name: 'UPS SurePost under 1lb',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        applicableSurchargeIds: [
          'ups-das-surepost',
          'ups-edas-surepost',
          'ups-surepost-handling',
          'ups-surepost-peak-handling',
          'ups-peak-surepost',
          'ups-fuel-ground',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'carrier_approval_required',
            countries: ['US'],
            exclusionsByRegion: {
              US: ['AA', 'HI', 'AS', 'PR', 'VI', 'AE', 'CZ', 'AK', 'GU', 'AP'],
            },
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'standard',
        applicableServiceLevels: ['standard'],
        carrierZoneKeyTypeByCountry: {
          US: 'postal3_to_postal',
        },
        rateTableType: 'sub_units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 60.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'min',
              combined: 0.0,
              length: 6.0,
              width: 4.0,
              height: 0.75,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_volume',
              combined: 864.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 1.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: true,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ups-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ups-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ups-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ups-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'ups-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'ups-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'ups-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'ups-zone-10',
            name: 'Zone 10',
          },
          {
            zoneId: 'ups-zone-11',
            name: 'Zone 11',
          },
          {
            zoneId: 'ups-zone-12',
            name: 'Zone 12',
          },
          {
            zoneId: 'ups-zone-13',
            name: 'Zone 13',
          },
        ],
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-worldwide-express-service-method',
        name: 'UPS Worldwide Express',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        applicableSurchargeIds: [
          'ups-rdas-intl',
          'ups-residential-air-intl',
          'ups-handling-intl',
          'ups-handling-large-package-intl',
          'ups-peak-au-nz',
          'ups-peak-intl',
          'ups-peak-large-package',
          'ups-peak-handling-intl',
          'ups-saturday',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-international-export',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'not_supported',
            countries: [],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'international_one_to_three_day_early',
        applicableServiceLevels: ['international_one_to_three_day_early', 'international_one_to_three_day'],
        carrierZoneKeyTypeByCountry: {
          AU: 'any_country_to_any_country',
          CA: 'any_US_origin_to_postal_group',
          GB: 'any_country_to_any_country',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-81',
            name: 'Zone 81',
          },
          {
            zoneId: 'ups-zone-82',
            name: 'Zone 82',
          },
          {
            zoneId: 'ups-zone-901',
            name: 'Zone 901',
          },
          {
            zoneId: 'ups-zone-902',
            name: 'Zone 902',
          },
          {
            zoneId: 'ups-zone-903',
            name: 'Zone 903',
          },
          {
            zoneId: 'ups-zone-904',
            name: 'Zone 904',
          },
          {
            zoneId: 'ups-zone-905',
            name: 'Zone 905',
          },
          {
            zoneId: 'ups-zone-906',
            name: 'Zone 906',
          },
          {
            zoneId: 'ups-zone-907',
            name: 'Zone 907',
          },
          {
            zoneId: 'ups-zone-908',
            name: 'Zone 908',
          },
          {
            zoneId: 'ups-zone-909',
            name: 'Zone 909',
          },
          {
            zoneId: 'ups-zone-911',
            name: 'Zone 911',
          },
          {
            zoneId: 'ups-zone-912',
            name: 'Zone 912',
          },
          {
            zoneId: 'ups-zone-913',
            name: 'Zone 913',
          },
          {
            zoneId: 'ups-zone-920',
            name: 'Zone 920',
          },
          {
            zoneId: 'ups-zone-921',
            name: 'Zone 921',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'ups-worldwide-saver-service-method',
        name: 'UPS Worldwide Saver',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        applicableSurchargeIds: [
          'ups-rdas-intl',
          'ups-residential-air-intl',
          'ups-handling-large-package-intl',
          'ups-handling-intl',
          'ups-peak-au-nz',
          'ups-peak-intl',
          'ups-peak-large-package',
          'ups-peak-handling-intl',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-international-export',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'not_supported',
            countries: [],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'standard',
        applicableServiceLevels: ['international_one_to_three_day', 'standard'],
        carrierZoneKeyTypeByCountry: {
          AU: 'any_country_to_any_country',
          CA: 'any_US_origin_to_postal_group',
          GB: 'any_country_to_any_country',
          GU: 'any_country_to_any_country',
          VI: 'any_country_to_any_country',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-401',
            name: 'Zone 401',
          },
          {
            zoneId: 'ups-zone-402',
            name: 'Zone 402',
          },
          {
            zoneId: 'ups-zone-403',
            name: 'Zone 403',
          },
          {
            zoneId: 'ups-zone-404',
            name: 'Zone 404',
          },
          {
            zoneId: 'ups-zone-405',
            name: 'Zone 405',
          },
          {
            zoneId: 'ups-zone-406',
            name: 'Zone 406',
          },
          {
            zoneId: 'ups-zone-407',
            name: 'Zone 407',
          },
          {
            zoneId: 'ups-zone-408',
            name: 'Zone 408',
          },
          {
            zoneId: 'ups-zone-409',
            name: 'Zone 409',
          },
          {
            zoneId: 'ups-zone-411',
            name: 'Zone 411',
          },
          {
            zoneId: 'ups-zone-412',
            name: 'Zone 412',
          },
          {
            zoneId: 'ups-zone-413',
            name: 'Zone 413',
          },
          {
            zoneId: 'ups-zone-481',
            name: 'Zone 481',
          },
          {
            zoneId: 'ups-zone-482',
            name: 'Zone 482',
          },
          {
            zoneId: 'ups-zone-484',
            name: 'Zone 484',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'ups-worldwide-expedited-service-method',
        name: 'UPS Worldwide Expedited',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        applicableSurchargeIds: [
          'ups-rdas-intl',
          'ups-residential-air-intl',
          'ups-handling-intl',
          'ups-handling-large-package-intl',
          'ups-peak-au-nz',
          'ups-peak-intl',
          'ups-peak-large-package',
          'ups-peak-handling-intl',
          'ups-signature',
          'ups-signature-resident',
          'ups-signature-adult-resident',
          'ups-signature-adult',
          'ups-fuel-air-international-export',
        ],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: {
          dangerousGoods: {
            supportStrategy: 'not_supported',
          },
          limitedQuantity: {
            supportStrategy: 'not_supported',
            countries: [],
            exclusionsByRegion: {},
            exclusionsByPostalCode: {},
          },
        },
        serviceLevel: 'international_two_to_five_day',
        applicableServiceLevels: ['international_two_to_five_day'],
        carrierZoneKeyTypeByCountry: {
          AU: 'any_country_to_any_country',
          CA: 'any_US_origin_to_postal_group',
          GB: 'any_country_to_any_country',
        },
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-71',
            name: 'Zone 71',
          },
          {
            zoneId: 'ups-zone-72',
            name: 'Zone 72',
          },
          {
            zoneId: 'ups-zone-74',
            name: 'Zone 74',
          },
          {
            zoneId: 'ups-zone-601',
            name: 'Zone 601/631',
          },
          {
            zoneId: 'ups-zone-602',
            name: 'Zone 602/632',
          },
          {
            zoneId: 'ups-zone-603',
            name: 'Zone 603/633',
          },
          {
            zoneId: 'ups-zone-604',
            name: 'Zone 604/634',
          },
          {
            zoneId: 'ups-zone-605',
            name: 'Zone 605/635',
          },
          {
            zoneId: 'ups-zone-606',
            name: 'Zone 606/636',
          },
          {
            zoneId: 'ups-zone-607',
            name: 'Zone 607/637',
          },
          {
            zoneId: 'ups-zone-608',
            name: 'Zone 608/638',
          },
          {
            zoneId: 'ups-zone-609',
            name: 'Zone 609/639',
          },
          {
            zoneId: 'ups-zone-611',
            name: 'Zone 611/641',
          },
          {
            zoneId: 'ups-zone-612',
            name: 'Zone 612/642',
          },
          {
            zoneId: 'ups-zone-613',
            name: 'Zone 613/643',
          },
          {
            zoneId: 'ups-zone-620',
            name: 'Zone 620',
          },
          {
            zoneId: 'ups-zone-621',
            name: 'Zone 621',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
    ],
    returnsServiceMethods: [
      {
        serviceMethodId: 'ups-returns-service-method',
        name: 'UPS Returns Service',
        credentialStructures: [],
        dimensionalWeight: null,
        destinationType: 'all',
        hazmat: null,
        serviceLevel: null,
        applicableServiceLevels: [],
        carrierZoneKeyTypeByCountry: null,
        rateTableType: null,
        restrictions: null,
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        failoverUndeliverable: false,
        zones: [
          {
            zoneId: 'ups-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'ups-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'ups-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'ups-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'ups-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'ups-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'ups-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'ups-zone-44',
            name: 'Zone 44',
          },
          {
            zoneId: 'ups-zone-45',
            name: 'Zone 45',
          },
          {
            zoneId: 'ups-zone-46',
            name: 'Zone 46',
          },
        ],
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'none',
      },
    ],
    surchargeTypes: [
      'residential_air',
      'residential_ground',
      'fuel_air_domestic',
      'fuel_air_international_export',
      'fuel_air_international_import',
      'fuel_ground',
      'delivery_commercial_air',
      'delivery_commercial_ground',
      'delivery_residential_air',
      'delivery_residential_ground',
      'extended_delivery_commercial_air',
      'extended_delivery_commercial_ground',
      'extended_delivery_residential_air',
      'extended_delivery_residential_ground',
      'alaska_delivery_commercial_air',
      'alaska_delivery_commercial_ground',
      'alaska_delivery_residential_air',
      'alaska_delivery_residential_ground',
      'hawaii_delivery_commercial_air',
      'hawaii_delivery_commercial_ground',
      'hawaii_delivery_residential_air',
      'hawaii_delivery_residential_ground',
      'international_delivery_area',
      'international_extended_delivery_area',
      'saturday_delivery',
      'signature',
      'signature_adult',
    ],
    orderedSurcharges: [
      {
        carrierSurchargeId: 'ups-das-ground-commercial',
        surchargeName: 'UPS ground commercial delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'commercial',
        filterToTransportationType: 'ground',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-edas-ground-commercial',
        surchargeName: 'UPS ground commercial extended delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'commercial',
        filterToTransportationType: 'ground',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-das-air-commercial',
        surchargeName: 'UPS air commercial delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'commercial',
        filterToTransportationType: 'air',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-edas-air-commercial',
        surchargeName: 'UPS air commercial extended delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'commercial',
        filterToTransportationType: 'air',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-das-ground-residential',
        surchargeName: 'UPS ground residential delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'residential',
        filterToTransportationType: 'ground',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-edas-ground-residential',
        surchargeName: 'UPS ground residential extended delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'residential',
        filterToTransportationType: 'ground',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-das-air-residential',
        surchargeName: 'UPS air residential delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'residential',
        filterToTransportationType: 'air',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-edas-air-residential',
        surchargeName: 'UPS air residential extended delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: 'residential',
        filterToTransportationType: 'air',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-rdas',
        surchargeName: 'UPS remote area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-rdas-alaska',
        surchargeName: 'UPS remote area surcharge - Alaska',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-rdas-hawaii',
        surchargeName: 'UPS remote area surcharge - Hawaii',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-rdas-intl',
        surchargeName: 'UPS remote area surcharge - International',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-das-surepost',
        surchargeName: 'UPS SurePost delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-edas-surepost',
        surchargeName: 'UPS SurePost extended delivery area surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'delivery-area',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: true,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-residential-air-domestic',
        surchargeName: 'UPS domestic air residential surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'residential',
        filterToDestinationType: 'residential',
        filterToTransportationType: 'air',
        filterToCountryCodes: ['US', 'PR'],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-residential-air-intl',
        surchargeName: 'UPS air residential surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'residential',
        filterToDestinationType: 'residential',
        filterToTransportationType: 'air',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-residential-ground',
        surchargeName: 'UPS ground residential surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'residential',
        filterToDestinationType: 'residential',
        filterToTransportationType: 'ground',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-handling-large-package-commercial-zone-2',
        surchargeName: 'UPS commercial large package surcharge zone 2',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: 'commercial',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: ['ups-zone-2', 'ups-zone-102', 'ups-zone-132', 'ups-zone-202', 'ups-zone-242', 'ups-zone-302'],
      },
      {
        carrierSurchargeId: 'ups-handling-large-package-commercial-zone-3-4',
        surchargeName: 'UPS commercial large package surcharge zones 3-4',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: 'commercial',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [
          'ups-zone-103',
          'ups-zone-104',
          'ups-zone-133',
          'ups-zone-134',
          'ups-zone-203',
          'ups-zone-204',
          'ups-zone-243',
          'ups-zone-244',
          'ups-zone-3',
          'ups-zone-303',
          'ups-zone-304',
          'ups-zone-4',
        ],
      },
      {
        carrierSurchargeId: 'ups-handling-large-package-commercial-zone-5-plus',
        surchargeName: 'UPS commercial large package surcharge zones 5 plus',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: 'commercial',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-handling-large-package-residential-zone-2',
        surchargeName: 'UPS residential large package surcharge zone 2',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: 'residential',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: ['ups-zone-2', 'ups-zone-102', 'ups-zone-132', 'ups-zone-202', 'ups-zone-242', 'ups-zone-302'],
      },
      {
        carrierSurchargeId: 'ups-handling-large-package-residential-zone-3-4',
        surchargeName: 'UPS residential large package surcharge zones 3-4',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: 'residential',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [
          'ups-zone-103',
          'ups-zone-104',
          'ups-zone-133',
          'ups-zone-134',
          'ups-zone-203',
          'ups-zone-204',
          'ups-zone-243',
          'ups-zone-244',
          'ups-zone-3',
          'ups-zone-303',
          'ups-zone-304',
          'ups-zone-4',
        ],
      },
      {
        carrierSurchargeId: 'ups-handling-large-package-residential-zone-5-plus',
        surchargeName: 'UPS residential large package surcharge zones 5 plus',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: 'residential',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-handling-large-package-intl',
        surchargeName: 'UPS international large package surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-handling-weight-zone-2',
        surchargeName: 'UPS additional handling weight surcharge Zone 2',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 50.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: ['ups-zone-2', 'ups-zone-102', 'ups-zone-132', 'ups-zone-202', 'ups-zone-242', 'ups-zone-302'],
      },
      {
        carrierSurchargeId: 'ups-handling-weight-zone-3-4',
        surchargeName: 'UPS additional handling weight surcharge Zones 3,4',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 50.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [
          'ups-zone-103',
          'ups-zone-104',
          'ups-zone-133',
          'ups-zone-134',
          'ups-zone-203',
          'ups-zone-204',
          'ups-zone-243',
          'ups-zone-244',
          'ups-zone-3',
          'ups-zone-303',
          'ups-zone-304',
          'ups-zone-4',
        ],
      },
      {
        carrierSurchargeId: 'ups-handling-weight-zone-5plus',
        surchargeName: 'UPS additional handling weight surcharge Zones 5+',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 50.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-handling-dimension-zone-2',
        surchargeName: 'UPS additional handling dimension surcharge Zone 2',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 105.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 48.0,
              width: 30.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: ['ups-zone-2', 'ups-zone-102', 'ups-zone-132', 'ups-zone-202', 'ups-zone-242', 'ups-zone-302'],
      },
      {
        carrierSurchargeId: 'ups-handling-dimension-zone-3-4',
        surchargeName: 'UPS additional handling dimension surcharge Zones 3,4',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 105.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 48.0,
              width: 30.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [
          'ups-zone-103',
          'ups-zone-104',
          'ups-zone-133',
          'ups-zone-134',
          'ups-zone-203',
          'ups-zone-204',
          'ups-zone-243',
          'ups-zone-244',
          'ups-zone-3',
          'ups-zone-303',
          'ups-zone-304',
          'ups-zone-4',
        ],
      },
      {
        carrierSurchargeId: 'ups-handling-dimension-zone-5plus',
        surchargeName: 'UPS additional handling dimension surcharge Zones 5+',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 105.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 48.0,
              width: 30.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-surepost-handling',
        surchargeName: 'UPS SurePost additional handling surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 34.0,
              width: 17.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 35.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-handling-intl',
        surchargeName: 'UPS International additional handling surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 105.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 48.0,
              width: 30.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-peak-au-nz',
        surchargeName: 'UPS International to AU/NZ peak rule C surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak-intl',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: ['AU', 'NZ'],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-peak-intl',
        surchargeName: 'UPS International peak rule G surcharge',
        surchargeFeeType: 'per_pound',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak-intl',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-peak-large-package',
        surchargeName: 'UPS peak large package rule H surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak_handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-peak-handling',
        surchargeName: 'UPS peak handling Rule H surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak_handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 50.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-peak-handling-intl',
        surchargeName: 'UPS international peak handling Rule H surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak_handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 96.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-surepost-peak-handling',
        surchargeName: 'UPS SurePost peak handling rule H surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak_handling',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max',
              combined: 0.0,
              length: 34.0,
              width: 17.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: null,
              thresholdType: 'max',
              weight: 35.0,
              weightUnit: 'lb',
            },
          ],
          maxCustomsInfoValue: [],
        },
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-peak-surepost',
        surchargeName: 'UPS Surepost peak rule I surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak-residential',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-peak-ground-residential',
        surchargeName: 'UPS residential ground peak rule I surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'peak-residential',
        filterToDestinationType: 'residential',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-saturday-commercial',
        surchargeName: 'UPS Saturday commercial delivery surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'saturday',
        filterToDestinationType: 'commercial',
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: true,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-saturday',
        surchargeName: 'UPS Saturday delivery surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'saturday',
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: true,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-signature',
        surchargeName: 'UPS signature surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: null,
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: 'signature',
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-signature-resident',
        surchargeName: 'UPS resident signature surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: null,
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: 'resident_signature',
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-signature-adult-resident',
        surchargeName: 'UPS adult resident signature surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: null,
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: 'adult_resident_signature',
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-signature-adult',
        surchargeName: 'UPS adult signature surcharge',
        surchargeFeeType: 'fixed',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: null,
        filterToDestinationType: null,
        filterToTransportationType: null,
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: 'adult_signature',
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-fuel-air-domestic',
        surchargeName: 'UPS fuel air domestic surcharge',
        surchargeFeeType: 'percentage',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'fuel',
        filterToDestinationType: null,
        filterToTransportationType: 'air',
        filterToCountryCodes: ['US', 'PR'],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-fuel-air-international-export',
        surchargeName: 'UPS fuel air international export surcharge',
        surchargeFeeType: 'percentage',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'fuel',
        filterToDestinationType: null,
        filterToTransportationType: 'air',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
      {
        carrierSurchargeId: 'ups-fuel-ground',
        surchargeName: 'UPS fuel ground surcharge',
        surchargeFeeType: 'percentage',
        active: true,
        mustIncludeExpirationDateTime: false,
        surchargeGroup: 'fuel',
        filterToDestinationType: null,
        filterToTransportationType: 'ground',
        filterToCountryCodes: [],
        filterToThreshold: null,
        filterToPostalKeyRequired: null,
        filterToDeliverySignatureType: null,
        filterToSelectedSaturdayDelivery: null,
        filterToShipmentVolumePercentageExceeding: null,
        filterToZoneIds: [],
      },
    ],
    fuelSurchargeAppliedToOnlyBaseRate: false,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
      {
        height: 8.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
    ],
    validLabelDpis: [203],
    hazmatSupported: true,
    active: true,
    carrierAccountAddressTypes: ['shipper'],
  },
  {
    carrierId: 'fedex',
    name: 'FedEx Corporation',
    status: CarrierStatuses.AVAILABLE,
    credentialStructures: [
      {
        credentialStructureId: 'fedex-standard-credentials',
        name: 'FedEx Standard Credentials',
        credentialProperties: [
          {
            credentialId: 'fedex-account-number',
            name: 'FedEx Account Number',
          },
        ],
      },
    ],
    shipiumCredentialStructures: [
      {
        credentialStructureId: 'fedex-shipium-credentials',
        name: 'Shipium Credentials for Fedex',
        credentialProperties: [
          {
            credentialId: FEDEX_SHIPIUM_API_KEY,
            name: 'FedEx Shipium API Key',
          },
          {
            credentialId: FEDEX_SHIPIUM_API_PASSWORD,
            name: 'FedEx Shipium API Password',
          },
          {
            credentialId: 'fedex-shipium-account-number',
            name: 'FedEx Shipium Account Number',
          },
          {
            credentialId: 'fedex-shipium-meter-number',
            name: 'FedEx Shipium Meter Number',
          },
        ],
      },
    ],
    maxTrackingIdRequestCount: 50,
    serviceMethods: [
      {
        serviceMethodId: 'fedex-ground-service-method',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        name: 'FedEx Ground',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'fedex-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'fedex-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'fedex-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'fedex-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'fedex-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'fedex-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'fedex-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'fedex-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'fedex-zone-14',
            name: 'Zone 14',
          },
          {
            zoneId: 'fedex-zone-17',
            name: 'Zone 17',
          },
          {
            zoneId: 'fedex-zone-22',
            name: 'Zone 22',
          },
          {
            zoneId: 'fedex-zone-23',
            name: 'Zone 23',
          },
          {
            zoneId: 'fedex-zone-25',
            name: 'Zone 25',
          },
          {
            zoneId: 'fedex-zone-51',
            name: 'Zone 51',
          },
          {
            zoneId: 'fedex-zone-54',
            name: 'Zone 54',
          },
          {
            zoneId: 'fedex-zone-92',
            name: 'Zone 92',
          },
          {
            zoneId: 'fedex-zone-96',
            name: 'Zone 96',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'fedex-home-delivery-service-method',
        name: 'FedEx Home Delivery',
        credentialStructures: null,
        destinationType: 'residential',
        serviceLevel: 'standard',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'fedex-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'fedex-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'fedex-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'fedex-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'fedex-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'fedex-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'fedex-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'fedex-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'fedex-zone-14',
            name: 'Zone 14',
          },
          {
            zoneId: 'fedex-zone-17',
            name: 'Zone 17',
          },
          {
            zoneId: 'fedex-zone-22',
            name: 'Zone 22',
          },
          {
            zoneId: 'fedex-zone-23',
            name: 'Zone 23',
          },
          {
            zoneId: 'fedex-zone-25',
            name: 'Zone 25',
          },
          {
            zoneId: 'fedex-zone-92',
            name: 'Zone 92',
          },
          {
            zoneId: 'fedex-zone-96',
            name: 'Zone 96',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'fedex-smartpost-service-method',
        name: 'FedEx SmartPost',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: [
          {
            credentialStructureId: 'fedex-standard-credentials',
            name: 'FedEx Standard Credentials',
            credentialProperties: [
              {
                credentialId: 'fedex-smartpost-hub-id',
                name: 'FedEx SmartPost HubId',
              },
            ],
          },
        ],
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'fedex-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'fedex-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'fedex-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'fedex-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'fedex-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'fedex-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'fedex-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'fedex-zone-9',
            name: 'Zone 9',
          },
        ],
        applicableSurchargeIds: [],
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'fedex-priority-overnight-service-method',
        name: 'FedEx Priority Overnight',
        applicableSurchargeIds: [],
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'priority_overnight',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 119.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'fedex-express-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'fedex-express-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'fedex-express-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'fedex-express-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'fedex-express-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'fedex-express-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'fedex-express-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'fedex-express-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'fedex-express-zone-10',
            name: 'Zone 10',
          },
          {
            zoneId: 'fedex-express-zone-11',
            name: 'Zone 11',
          },
          {
            zoneId: 'fedex-express-zone-12',
            name: 'Zone 12',
          },
          {
            zoneId: 'fedex-express-zone-13',
            name: 'Zone 13',
          },
          {
            zoneId: 'fedex-express-zone-14',
            name: 'Zone 14',
          },
          {
            zoneId: 'fedex-express-zone-15',
            name: 'Zone 15',
          },
          {
            zoneId: 'fedex-express-zone-16',
            name: 'Zone 16',
          },
          {
            zoneId: 'fedex-express-zone-within-islands',
            name: 'Zone Within Islands',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'fedex-standard-overnight-service-method',
        applicableSurchargeIds: [],
        name: 'FedEx Standard Overnight',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'overnight',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 119.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'fedex-express-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'fedex-express-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'fedex-express-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'fedex-express-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'fedex-express-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'fedex-express-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'fedex-express-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'fedex-express-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'fedex-express-zone-13',
            name: 'Zone 13',
          },
          {
            zoneId: 'fedex-express-zone-14',
            name: 'Zone 14',
          },
          {
            zoneId: 'fedex-express-zone-15',
            name: 'Zone 15',
          },
          {
            zoneId: 'fedex-express-zone-16',
            name: 'Zone 16',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'fedex-2day-service-method',
        name: 'FedEx 2 Day',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'two_day',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 119.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'fedex-express-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'fedex-express-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'fedex-express-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'fedex-express-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'fedex-express-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'fedex-express-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'fedex-express-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'fedex-express-zone-9',
            name: 'Zone 9',
          },
          {
            zoneId: 'fedex-express-zone-10',
            name: 'Zone 10',
          },
          {
            zoneId: 'fedex-express-zone-11',
            name: 'Zone 11',
          },
          {
            zoneId: 'fedex-express-zone-12',
            name: 'Zone 12',
          },
          {
            zoneId: 'fedex-express-zone-13',
            name: 'Zone 13',
          },
          {
            zoneId: 'fedex-express-zone-14',
            name: 'Zone 14',
          },
          {
            zoneId: 'fedex-express-zone-15',
            name: 'Zone 15',
          },
          {
            zoneId: 'fedex-express-zone-16',
            name: 'Zone 16',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'fedex-express-saver-service-method',
        name: 'FedEx Express Saver',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'three_day',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 119.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'fedex-express-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'fedex-express-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'fedex-express-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'fedex-express-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'fedex-express-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'fedex-express-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'fedex-express-zone-8',
            name: 'Zone 8',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'fedex-intl-priority-service-method',
        name: 'FedEx International Priority',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'three_day',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,

        supportedDeliveryCountries: ['PR', 'GU'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'fedex-intl-zone-PR',
            name: 'Puerto Rico',
          },
          {
            zoneId: 'fedex-intl-zone-J',
            name: 'Guam',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'fedex-intl-economy-service-method',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        name: 'FedEx International Economy',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['PR', 'GU'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 165.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'fedex-intl-zone-PR',
            name: 'Puerto Rico',
          },
          {
            zoneId: 'fedex-intl-zone-J',
            name: 'Guam',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'none',
      },
    ],
    returnsServiceMethods: [],
    surchargeTypes: [
      'residential_ground',
      'residential_air',
      'fuel_ground',
      'fuel_air_domestic',
      'fuel_air_international_export',
      'alaska_delivery_commercial_air',
      'alaska_delivery_commercial_ground',
      'alaska_delivery_residential_air',
      'alaska_delivery_residential_ground',
      'hawaii_delivery_commercial_air',
      'hawaii_delivery_commercial_ground',
      'hawaii_delivery_residential_air',
      'hawaii_delivery_residential_ground',
      'saturday_delivery',
      'signature',
      'signature_resident',
      'signature_adult',
      'signature_adult_resident',
    ],
    fuelSurchargeAppliedToOnlyBaseRate: false,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
      {
        height: 8.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
      {
        height: 9.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
    ],
    validLabelDpis: [203],
    active: true,
  },
  {
    carrierId: 'lso',
    name: 'Lone Star Overnight',
    status: CarrierStatuses.UNAVAILABLE,
    credentialStructures: [
      {
        credentialStructureId: 'lso-standard-credentials',
        name: 'LSO Standard Credentials',
        credentialProperties: [
          {
            credentialId: 'lso-account-number',
            name: 'LSO Account Number',
          },
        ],
      },
    ],
    shipiumCredentialStructures: [],
    maxTrackingIdRequestCount: 100,
    serviceMethods: [
      {
        serviceMethodId: 'lso-ground-service-method',
        name: 'LSO Ground',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        status: CarrierStatuses.UNAVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'lso-priority-next-day-service-method',
        name: 'LSO Priority Next Day',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'next_day',
        status: CarrierStatuses.UNAVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'lso-priority-next-day-simple-service-method',
        name: 'LSO Priority Next Day Simple',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'next_day',
        status: CarrierStatuses.UNAVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'lso-economy-next-day-service-method',
        name: 'LSO Economy Next Day',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'next_day',
        supportedDeliveryCountries: ['US'],
        status: CarrierStatuses.UNAVAILABLE,
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'lso-economy-next-day-simple-service-method',
        name: 'LSO Economy Next Day Simple',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'next_day',
        status: CarrierStatuses.UNAVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'lso-second-day-service-method',
        name: 'LSO Second Day',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'two_day',
        status: CarrierStatuses.UNAVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'lso-second-day-simple-service-method',
        name: 'LSO Second Day Simple',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'two_day',
        supportedDeliveryCountries: ['US'],
        status: CarrierStatuses.UNAVAILABLE,
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 150.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'none',
      },
      {
        serviceMethodId: 'lso-ecomm-service-method',
        name: 'LSO eCommerce',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        status: CarrierStatuses.UNAVAILABLE,
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
            {
              packageType: 'box',
              thresholdType: 'max_length',
              combined: 0.0,
              length: 108.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 10.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'lso-ecomm-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'lso-ecomm-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'lso-ecomm-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'lso-ecomm-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'lso-ecomm-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'lso-ecomm-zone-7',
            name: 'Zone 7',
          },
        ],
        supportedDeliverySignatureTypes: ['signature', 'resident_signature', 'adult_signature'],
        supportedSaturdayDeliveryType: 'none',
      },
    ],
    returnsServiceMethods: [],
    surchargeTypes: [
      'residential_ground',
      'fuel_ground',
      'fuel_air_domestic',
      'delivery_commercial_ground',
      'delivery_residential_ground',
      'extended_delivery_commercial_ground',
      'extended_delivery_residential_ground',
      'saturday_delivery',
      'signature',
      'signature_resident',
      'signature_adult',
    ],
    fuelSurchargeAppliedToOnlyBaseRate: false,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
    ],
    validLabelDpis: [203],
    active: true,
  },
  {
    carrierId: 'cdl',
    name: 'CDL',
    status: CarrierStatuses.AVAILABLE,
    credentialStructures: [
      {
        credentialStructureId: 'cdl-standard-credentials',
        name: 'CDL Standard Credentials',
        credentialProperties: [
          {
            credentialId: 'cdl-account-number',
            name: 'CDL Account Number',
          },
          {
            credentialId: 'cdl-api-username',
            name: 'CDL API Username',
          },
          {
            credentialId: 'cdl-api-password',
            name: 'CDL API Password',
          },
        ],
      },
    ],
    shipiumCredentialStructures: [],
    maxTrackingIdRequestCount: 10,
    serviceMethods: [
      {
        serviceMethodId: 'cdl-service-method',
        name: 'CDL Distribution',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        status: CarrierStatuses.AVAILABLE,
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 100.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: false,
        zones: [
          {
            zoneId: 'cdl-zone-1',
            name: 'Zone 1',
          },
          {
            zoneId: 'cdl-zone-2',
            name: 'Zone 2',
          },
        ],
        supportedDeliverySignatureTypes: ['signature'],
        supportedSaturdayDeliveryType: 'none',
      },
    ],
    returnsServiceMethods: [],
    surchargeTypes: ['fuel_ground', 'incentive'],
    fuelSurchargeAppliedToOnlyBaseRate: false,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
    ],
    validLabelDpis: [203],
    active: true,
  },
  {
    carrierId: 'usps',
    name: 'United States Postal Service (USPS)',
    status: CarrierStatuses.AVAILABLE,
    credentialStructures: [
      {
        credentialStructureId: 'usps-standard-credentials',
        name: 'USPS Standard Credentials',
        credentialProperties: [
          {
            credentialId: 'usps-api-user-id',
            name: 'USPS API User ID',
          },
          {
            credentialId: 'usps-api-user-password',
            name: 'USPS API User Password',
          },
        ],
      },
      {
        credentialStructureId: 'endicia-credentials',
        name: 'Endicia Credentials',
        credentialProperties: [
          {
            credentialId: 'endicia-account-id',
            name: 'Endicia Account ID',
          },
          {
            credentialId: 'endicia-passphrase',
            name: 'Endicia Passphrase',
          },
        ],
      },
    ],
    shipiumCredentialStructures: [],
    maxTrackingIdRequestCount: 10,
    serviceMethods: [
      {
        serviceMethodId: 'usps-parcel-select-service-method',
        name: 'USPS Parcel Select',
        credentialStructures: null,
        status: CarrierStatuses.AVAILABLE,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units_and_sub_units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 130.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'ground',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'usps-zone-1',
            name: 'Zone 1',
          },
          {
            zoneId: 'usps-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'usps-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'usps-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'usps-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'usps-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'usps-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'usps-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'usps-zone-9',
            name: 'Zone 9',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'usps-priority-mail-service-method',
        name: 'USPS Priority Mail',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        status: CarrierStatuses.AVAILABLE,
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 108.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'usps-zone-1',
            name: 'Zone 1',
          },
          {
            zoneId: 'usps-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'usps-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'usps-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'usps-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'usps-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'usps-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'usps-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'usps-zone-9',
            name: 'Zone 9',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
      {
        serviceMethodId: 'usps-priority-mail-express-service-method',
        name: 'USPS Priority Mail Express',
        status: CarrierStatuses.AVAILABLE,
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        supportedDeliveryCountries: ['US'],
        rateTableType: 'units',
        restrictions: {
          dimensions: [
            {
              packageType: 'box',
              thresholdType: 'max_combined',
              combined: 108.0,
              length: 0.0,
              width: 0.0,
              height: 0.0,
              dimensionUnit: 'in',
            },
          ],
          weights: [
            {
              packageType: 'box',
              thresholdType: 'max',
              weight: 70.0,
              weightUnit: 'lb',
            },
          ],
        },
        transportationType: 'air',
        uspsPoBoxDeliverySupported: true,
        zones: [
          {
            zoneId: 'usps-zone-1',
            name: 'Zone 1',
          },
          {
            zoneId: 'usps-zone-2',
            name: 'Zone 2',
          },
          {
            zoneId: 'usps-zone-3',
            name: 'Zone 3',
          },
          {
            zoneId: 'usps-zone-4',
            name: 'Zone 4',
          },
          {
            zoneId: 'usps-zone-5',
            name: 'Zone 5',
          },
          {
            zoneId: 'usps-zone-6',
            name: 'Zone 6',
          },
          {
            zoneId: 'usps-zone-7',
            name: 'Zone 7',
          },
          {
            zoneId: 'usps-zone-8',
            name: 'Zone 8',
          },
          {
            zoneId: 'usps-zone-9',
            name: 'Zone 9',
          },
        ],
        supportedDeliverySignatureTypes: [
          'signature',
          'resident_signature',
          'adult_signature',
          'adult_resident_signature',
        ],
        supportedSaturdayDeliveryType: 'all_zip_codes',
      },
    ],
    returnsServiceMethods: [],
    surchargeTypes: ['signature', 'signature_resident', 'signature_adult', 'signature_adult_resident'],
    fuelSurchargeAppliedToOnlyBaseRate: false,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
      {
        height: 8.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
      {
        height: 4.0,
        width: 6.0,
        linearUnits: 'in',
        orientation: 'rotate_90',
      },
    ],
    validLabelDpis: [203, 300, 600],
    active: true,
  },
  {
    carrierId: 'noon',
    name: 'Noon',
    status: CarrierStatuses.AVAILABLE_SHIPIUM,
    credentialStructures: [],
    shipiumCredentialStructures: [],
    maxTrackingIdRequestCount: 100,
    serviceMethods: [
      {
        serviceMethodId: 'noon-ae-service-method',
        name: 'Noon AE',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        supportedDeliveryCountries: ['US', 'AS', 'GU', 'MH', 'FM', 'MP', 'PW', 'PR', 'VI'],
        // 'rateTableType': 'units',
        restrictions: {
          dimensions: [],
          weights: [],
        },
        // 'transportationType': 'ground',
        uspsPoBoxDeliverySupported: false,
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'none',
        carrierZoneKeyTypeByCountry: {
          US: 'any_country_to_any_country',
        },
        applicableServiceLevels: ['standard'],
        zones: [
          {
            zoneId: 'noon-zone-AE',
            name: 'United Arab Emirates',
          },
        ],
      },
      {
        serviceMethodId: 'noon-eg-service-method',
        name: 'Noon EG',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        supportedDeliveryCountries: ['US', 'AS', 'GU', 'MH', 'FM', 'MP', 'PW', 'PR', 'VI'],
        // 'rateTableType': 'units',
        restrictions: {
          dimensions: [],
          weights: [],
        },
        // 'transportationType': 'ground',
        uspsPoBoxDeliverySupported: false,
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'none',
        carrierZoneKeyTypeByCountry: {
          US: 'any_country_to_any_country',
        },
        applicableServiceLevels: ['standard'],
        zones: [
          {
            zoneId: 'noon-zone-EG',
            name: 'Egypt',
          },
        ],
      },
      {
        serviceMethodId: 'noon-sa-service-method',
        name: 'Noon SA',
        credentialStructures: null,
        destinationType: 'all',
        serviceLevel: 'standard',
        status: CarrierStatuses.AVAILABLE_SHIPIUM,
        supportedDeliveryCountries: ['US', 'AS', 'GU', 'MH', 'FM', 'MP', 'PW', 'PR', 'VI'],
        // 'rateTableType': 'units',
        restrictions: {
          dimensions: [],
          weights: [],
        },
        // 'transportationType': 'ground',
        uspsPoBoxDeliverySupported: false,
        supportedDeliverySignatureTypes: [],
        supportedSaturdayDeliveryType: 'none',
        carrierZoneKeyTypeByCountry: {
          US: 'any_country_to_any_country',
        },
        applicableServiceLevels: ['standard'],
        zones: [
          {
            zoneId: 'noon-zone-SA',
            name: 'Saudi Arabia',
          },
        ],
      },
    ],
    returnsServiceMethods: [],
    surchargeTypes: [],
    fuelSurchargeAppliedToOnlyBaseRate: false,
    validLabelSizes: [
      {
        height: 6.0,
        width: 4.0,
        linearUnits: 'in',
        orientation: 'rotate_0',
      },
    ],
    validLabelDpis: [203],
    active: true,
  },
];
export const carrierAccounts: any[] = [
  {
    active: true,
    archive: false,
    partnerId: mockPartner.partnerId,
    carrierAccountId: 'fedex123',
    carrierAccountUrn: uuid(),
    carrierId: 'fedex',
    carrier: carriers.find((val) => val.carrierId === 'fedex'),
    fulfillmentContexts: ['store'],
    name: 'FedEx Primary Account',
    credentialDefinition: {
      credentialStructureId: 'fedex-standard-credential',
      credentials: {
        'fedex-account-number': 'secret1212',
        'fedex-api-key': 'key123',
        'fedex-api-password': 'password',
        'fedex-meter-number': 'meternumber123',
      },
    },
    contact: {
      name: 'Shipi',
      emailAddress: 'shipi@gmail.com',
      phoneNumber: '215-912-8122',
    },
    fulfillmentCenters: [],
    serviceMethods: [
      {
        carrierAccountUrn: 'carrier:account:urn',
        carrierServiceMethodId: 'fedex-express-saver-service-method',
        serviceMethodUrn: 'fedex:service:method:urn',
        name: 'FedEx Express Saver',
        destinationType: 'all',
        transportationType: 'all',
        uspsPoBoxDeliverySupported: true,
        active: true,
        paramCalendar: [
          {
            startDateTime: '2020-01-01T08:00:00.000Z',
            endDateTime: '2020-12-15T08:00:00.000Z',
            name: '2020 Rates',
            active: true,
            serviceMethodParamId: uuid(),
            serviceMethodParamUrn: uuid(),
          },
          {
            startDateTime: '2020-12-16T08:00:00.000Z',
            endDateTime: '2020-12-31T08:00:00.000Z',
            name: 'Holiday 2020 Rates',
            active: true,
            serviceMethodParamId: uuid(),
            serviceMethodParamUrn: uuid(),
          },
          {
            startDateTime: '2021-01-01T08:00:00.000Z',
            endDateTime: '2021-12-31T08:00:00.000Z',
            name: '2021 Rates',
            active: true,
            serviceMethodParamId: uuid(),
            serviceMethodParamUrn: uuid(),
          },
        ],
        serviceMethodId: 'fedex-express-saver-service-method',
        carrierServiceMethod: {
          active: true,
          rateTableType: 'units_and_sub_units',
          serviceMethodId: 'fedex-express-saver-service-method',
          status: CarrierStatuses.AVAILABLE,
          name: 'FedEx Express Saver',
          restrictions: {
            dimensions: [
              {
                packageType: 'box',
                thresholdType: 'max_combined',
                combined: 165,
                length: 0,
                width: 0,
                height: 0,
                dimensionUnit: 'in',
              },
              {
                packageType: 'box',
                thresholdType: 'max_length',
                combined: 0,
                length: 119,
                width: 0,
                height: 0,
                dimensionUnit: 'in',
              },
            ],
            weights: [
              {
                packageType: 'box',
                thresholdType: 'max',
                weight: 150,
                weightUnit: 'lb',
              },
            ],
          },
          zones: [
            {
              zoneId: 'fedex-zone-2',
              name: 'Zone 2',
            },
            {
              zoneId: 'fedex-zone-3',
              name: 'Zone 3',
            },
            {
              zoneId: 'fedex-zone-4',
              name: 'Zone 4',
            },
            {
              zoneId: 'fedex-zone-5',
              name: 'Zone 5',
            },
            {
              zoneId: 'fedex-zone-6',
              name: 'Zone 6',
            },
            {
              zoneId: 'fedex-zone-7',
              name: 'Zone 7',
            },
            {
              zoneId: 'fedex-zone-8',
              name: 'Zone 8',
            },
          ],
        },
      },
    ],
  },
  {
    active: true,
    archive: false,
    partnerId: mockPartner.partnerId,
    carrierAccountId: 'ups123',
    carrierAccountUrn: uuid(),
    carrierId: 'ups',
    carrier: carriers.find((val) => val.carrierId === 'ups'),
    fulfillmentContexts: ['store'],
    name: 'UPS Account',
    credentialDefinition: {
      credentialStructureId: 'fedex-standard-credential',
      credentials: {
        'fedex-account-number': 'secret1212',
        'fedex-api-key': 'key123',
        'fedex-api-password': 'password',
        'fedex-meter-number': 'meternumber123',
      },
    },
    contact: {
      name: 'Shipi',
      emailAddress: 'shipi@gmail.com',
      phoneNumber: '215-912-8122',
    },
    fulfillmentCenters: [],
    serviceMethods: [
      {
        carrierAccountUrn: 'carrier:account:urn',
        carrierServiceMethodId: 'ups-next-day-air-early-service-method',
        serviceMethodUrn: 'ups:service:method:urn',
        name: 'UPS Next Day Air Early',
        destinationType: 'all',
        transportationType: 'all',
        uspsPoBoxDeliverySupported: true,
        active: true,
        paramCalendar: [
          {
            startDateTime: '2020-01-01T08:00:00.000Z',
            endDateTime: '2020-12-15T08:00:00.000Z',
            name: '2020 Rates',
            active: true,
            serviceMethodParamId: 'e4616f18-138f-459a-b634-bb8986264173',
            serviceMethodParamUrn: uuid(),
          },
          {
            startDateTime: '2020-12-16T08:00:00.000Z',
            endDateTime: '2020-12-31T08:00:00.000Z',
            name: 'Holiday 2020 Rates',
            active: true,
            serviceMethodParamId: 'be2ac97c-aa07-4828-872f-748709674985',
            serviceMethodParamUrn: uuid(),
          },
          {
            startDateTime: '2021-01-01T08:00:00.000Z',
            endDateTime: '2021-12-31T08:00:00.000Z',
            name: '2021 Rates',
            active: true,
            serviceMethodParamId: 'e4616f18-138f-459a-b634-bb8986264173',
            serviceMethodParamUrn: uuid(),
          },
        ],
        serviceMethodId: 'ups-next-day-air-early-service-method',
        carrierServiceMethod: {
          active: true,
          status: CarrierStatuses.AVAILABLE,
          rateTableType: 'units_and_sub_units',
          serviceMethodId: 'ups-next-day-air-early-service-method',
          name: 'UPS Next Day Air Early',
          restrictions: {
            dimensions: [
              {
                packageType: 'box',
                thresholdType: 'max_combined',
                combined: 165,
                length: 0,
                width: 0,
                height: 0,
                dimensionUnit: 'in',
              },
              {
                packageType: 'box',
                thresholdType: 'max_length',
                combined: 0,
                length: 119,
                width: 0,
                height: 0,
                dimensionUnit: 'in',
              },
            ],
            weights: [
              {
                packageType: 'box',
                thresholdType: 'max',
                weight: 150,
                weightUnit: 'lb',
              },
            ],
          },
          zones: [
            {
              zoneId: 'ups-zone-102',
              name: 'Zone 102',
            },
            {
              zoneId: 'ups-zone-103',
              name: 'Zone 103',
            },
            {
              zoneId: 'ups-zone-104',
              name: 'Zone 104',
            },
            {
              zoneId: 'ups-zone-105',
              name: 'Zone 105',
            },
            {
              zoneId: 'ups-zone-106',
              name: 'Zone 106',
            },
            {
              zoneId: 'ups-zone-107',
              name: 'Zone 107',
            },
            {
              zoneId: 'ups-zone-108',
              name: 'Zone 108',
            },
            {
              zoneId: 'ups-zone-124',
              name: 'Zone 124',
            },
          ],
        },
      },
    ],
  },
  {
    active: true,
    archive: false,
    partnerId: mockPartner.partnerId,
    carrierAccountId: 'noon-account',
    carrierAccountUrn: uuid(),
    carrierId: 'noon',
    carrier: carriers.find((val) => val.carrierId === 'noon'),
    fulfillmentContexts: ['store'],
    name: 'Noon Account',
    // credentialDefinition: null,
    contact: {
      name: 'Shipi',
      emailAddress: 'shipi@gmail.com',
      phoneNumber: '215-912-8122',
    },
    fulfillmentCenters: [],
    serviceMethods: [
      {
        carrierAccountUrn: 'carrier:account:urn',
        carrierServiceMethodId: 'noon-ae-service-method',
        serviceMethodUrn: 'ups:service:method:urn',
        name: 'Noon AE',
        destinationType: 'all',
        // transportationType: 'all',
        uspsPoBoxDeliverySupported: false,
        active: true,
        paramCalendar: [],
        serviceMethodId: 'noon-ae-service-method',
        carrierServiceMethod: {
          serviceMethodId: 'noon-ae-service-method',
          name: 'Noon AE',
          credentialStructures: null,
          destinationType: 'all',
          serviceLevel: 'standard',
          status: CarrierStatuses.AVAILABLE_SHIPIUM,
          supportedDeliveryCountries: ['US', 'AS', 'GU', 'MH', 'FM', 'MP', 'PW', 'PR', 'VI'],
          // 'rateTableType': 'units',
          restrictions: {
            dimensions: [],
            weights: [],
          },
          // 'transportationType': 'ground',
          uspsPoBoxDeliverySupported: false,
          supportedDeliverySignatureTypes: [],
          supportedSaturdayDeliveryType: 'none',
          carrierZoneKeyTypeByCountry: {
            US: 'any_country_to_any_country',
          },
          applicableServiceLevels: ['standard'],
          zones: [
            {
              zoneId: 'noon-zone-AE',
              name: 'United Arab Emirates',
            },
          ],
        },
      },
      {
        carrierAccountUrn: 'carrier:account:urn',
        carrierServiceMethodId: 'noon-eg-service-method',
        serviceMethodUrn: 'ups:service:method:urn',
        name: 'Noon EG',
        destinationType: 'all',
        // transportationType: 'all',
        uspsPoBoxDeliverySupported: false,
        active: true,
        paramCalendar: [],
        serviceMethodId: 'noon-eg-service-method',
        carrierServiceMethod: {
          serviceMethodId: 'noon-eg-service-method',
          name: 'Noon EG',
          credentialStructures: null,
          destinationType: 'all',
          serviceLevel: 'standard',
          status: CarrierStatuses.AVAILABLE_SHIPIUM,
          supportedDeliveryCountries: ['US', 'AS', 'GU', 'MH', 'FM', 'MP', 'PW', 'PR', 'VI'],
          // 'rateTableType': 'units',
          restrictions: {
            dimensions: [],
            weights: [],
          },
          // 'transportationType': 'ground',
          uspsPoBoxDeliverySupported: false,
          supportedDeliverySignatureTypes: [],
          supportedSaturdayDeliveryType: 'none',
          carrierZoneKeyTypeByCountry: {
            US: 'any_country_to_any_country',
          },
          applicableServiceLevels: ['standard'],
          zones: [
            {
              zoneId: 'noon-zone-EG',
              name: 'Egypt',
            },
          ],
        },
      },
      {
        carrierAccountUrn: 'carrier:account:urn',
        carrierServiceMethodId: 'noon-sa-service-method',
        serviceMethodUrn: 'ups:service:method:urn',
        name: 'Noon SA',
        destinationType: 'all',
        // transportationType: 'all',
        uspsPoBoxDeliverySupported: false,
        active: true,
        paramCalendar: [],
        serviceMethodId: 'noon-sa-service-method',
        carrierServiceMethod: {
          serviceMethodId: 'noon-sa-service-method',
          name: 'Noon SA',
          credentialStructures: null,
          destinationType: 'all',
          serviceLevel: 'standard',
          status: CarrierStatuses.AVAILABLE_SHIPIUM,
          supportedDeliveryCountries: ['US', 'AS', 'GU', 'MH', 'FM', 'MP', 'PW', 'PR', 'VI'],
          // 'rateTableType': 'units',
          restrictions: {
            dimensions: [],
            weights: [],
          },
          // 'transportationType': 'ground',
          uspsPoBoxDeliverySupported: false,
          supportedDeliverySignatureTypes: [],
          supportedSaturdayDeliveryType: 'none',
          carrierZoneKeyTypeByCountry: {
            US: 'any_country_to_any_country',
          },
          applicableServiceLevels: ['standard'],
          zones: [
            {
              zoneId: 'noon-zone-SA',
              name: 'Saudi Arabia',
            },
          ],
        },
      },
    ],
  },
];
